import { on } from "@arcgis/core/core/reactiveUtils"
import { add } from "lodash"

export const englishUS = {
  firstNameIsInvalid: 'This field is mandatory. Maximum of 100 characters are allowed.',
  invalidFirstName: 'Invalid First Name',
  invalidLastName: 'Invalid Last Name',
  lastNameIsInvalid: 'This field is mandatory. Maximum of 100 characters are allowed.',
  emailIsInvalid: 'Please enter a valid email address',
  organisationIsInvalid: 'Please enter maximum 100 characters',
  countryCodeIsNotSelected: 'Select your country',
  passwordIsInvalid: 'Password must be from 12 to 64 characters long and must contain at least one uppercase letter, lowercase letter, number, and symbol',
  confirmPasswordInvalid: 'The password and confirmation password do not match',
  passwordsNoMatchInvalid: 'Passwords don\'t match',
  confirmPasswordEmpty: 'Please confirm your password',
  termsAndConditionsNotAccepted: 'To proceed please read and accept Terms and Use',
  suchEmailAlreadyInUse: 'This email is already registered in the system',
  successfulRegistration: 'Your account has been successfully created. You can now login.',
  somethingWentWrong: 'Something went wrong - please contact us (info@keybiodiversityareas.org',
  ibaRelatedCriteriaHint: 'Specify related IBA criteria if applicable',
  passwordHint: 'Password must be from 12 to 64 characters long and must contain at least one uppercase letter, lowercase letter, number, and symbol',
  previousPasswordCantBeUsed: 'Previous password cannot be used',
  alreadyUsedOrExpired: 'The password reset link has expired or has already been used',
  firstNameLabel: 'First name',
  email: 'Email',
  seasonPlaceholder: "Select a season",
  password: 'Password',
  lastNameLabel: 'Last name',
  emailLabel: 'Email',
  organisationLabel: 'Organisation',
  countryLabel: 'Country',
  countryOfInterestLabel: 'Country of interest',
  interestSelectIsMandatory: 'Please select your country of interest from dropdown',
  numberOfKba: 'Number of sites',
  triggerSpecies: 'Trigger Species',
  kbaPartner: 'KBA Partner',
  kbaPartnerLabel: 'KBA Partner',
  passwordLabel: 'Password',
  confirmPasswordLabel: 'Confirm password',
  termsAndConditionsText: 'I agree to ',
  categoryDropdown: 'Category Dropdown',
  allCategories: 'All categories',
  createAccountButton: 'Create account',
  firstNamePlaceholder: 'Enter your first name',
  lastNamePlaceholder: 'Enter your last name',
  emailPlaceholder: 'Enter your email',
  searchPlaceholder: 'Search...',
  organisationPlaceholder: 'Organisation',
  passwordPlaceholder: 'Enter your password',
  newPasswordPlaceholder: 'Enter your new password',
  confirmPasswordPlaceholder: 'Confirm your password',
  confirmNewPasswordPlaceholder: 'Confirm your new password',
  enterAndConfirmNewPassword: 'Please enter and confirm new password',
  countryPlaceholder: 'Select your country',
  countryOfInterestPlaceholder: 'Select your main country or countries of interest',
  kbaPartnerPlaceholder: 'Select KBA Partner affiliation (if any)',
  alreadyHaveAnAccount: 'Already have an account?',
  signIn: 'Sign In',
  signUp: 'Sign up',
  signOut: 'Sign out',
  dontHaveAnAccount: 'Don\'t have an account?',
  changePassword: 'Change password',
  rememberMeCheckbox: 'Remember Me',
  forgotPassword: 'Forgot password?',
  pleaseEnterYourCredentials: 'Please enter your credentials',
  pleaseEnterYourEmail: 'Please enter your email',
  emailOrPasswordIncorrect: 'Invalid email or password',
  resetPassword: 'Reset password',
  rememberYourPassword: 'Remember your password',
  passwordChangeSuccessful: 'Your password was changed successfully',
  assessmentsHint: 'All assessments {assessmentNumber}',
  allAssessments: 'All assessments {assessmentsNumber}',
  allBiodiversityEvaluations:"All evaluations {assessmentsNumber}",
  reassessSite: 'Assess biodiversity',
  resetPasswordSuccessful: 'If this registration exists you will receive an email with instructions on how to reset your password within a few minutes',
  roleSelectLabel: 'Role',
  roleSelectPlaceholder: 'Select Role',
  roleSelectIsMandatory: 'Please select your role from dropdown',
  pleaseEnterNewPassword: 'Please enter a new password',
  propose: 'Propose',
  proposeSite: 'Add new site',
  editProfile: 'Edit profile',
  profile: 'My profile',
  accountSettings: 'Account settings',
  terms: 'Terms of use',
  privacy: 'Privacy policy',
  dashboard: 'Dashboard',
  sites: 'Sites',
  users: 'Users',
  monitoring: 'Monitoring',
  forum: 'Forum',
  activeUsers: 'Active users',
  noMatchingFilterCriteria: 'No users match filtering criteria',
  clearFilters: 'Clear filters',
  moldova: 'Moldova',
  ncg: 'NCG',
  notifications: 'Notifications',
  nothingHereSoFar: 'Nothing here so far... ',
  proposerName: 'Proposer name',
  proposerEmail: 'Proposer email',
  noSensitiveSitesFound: 'No sensitive sites found',
  individual: 'Individual',
  '/': 'Home Page',
  '/terms-and-use': 'Terms of use',
  '/users': 'Users management',
  '/sites': 'Sites management',
  '/profile': 'Profile settings',
  '/sites/map': 'Sites management map',
  'registrationPage.pageTitle': 'Registration',
  showing: 'Showing',
  secretariat: 'Secretariat',
  // name: 'Last name first name',
  country: 'Country',
  countryOfInterest: 'Country of interest',
  role: 'User type',
  userStatus: 'Status',
  lastLogin: 'Last Login',
  actions: 'Actions',
  date: 'Date',
  time:'Time',
  usersAndAssessment: 'Users and Assessments',
  siteNameNational: 'Site name (National)',
  siteNameInternational: 'Site name (International)',
  siteNameEng: 'Site name (International)',
  year: 'Year',
  yearOfEstimate: 'Year of estimate',
  proposer: 'Proposer',
  lastProposer: 'Last proposer',
  siteStatus: 'Status',
  kbaStatus: 'KBA status',
  kbaCriteria: 'KBA criteria',
  kbaClassification: 'KBA classification',
  ibaStatus: 'IBA status',
  ibaCriteria: 'IBA criteria',
  noSitesMatchFilteringCriteria: 'No sites match filtering criteria',
  nothingMatchesYourSearch: 'Nothing matches your search',
  clearResults: 'Clear search results',
  searchUserPlaceholder: 'Name, country or user type...',
  search: 'Search',
  home: 'Home',
  lastName: 'Last name',
  firstName: 'First name',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm your new password',
  enterCurrentPassword: 'Enter your current password',
  enterNewPassword: 'Enter your new password',
  cancel: 'Cancel',
  enterOldPassword: 'Please enter your password',
  changeEmail: 'Change email',
  emailConfirmation: 'Email confirmation',
  changeEmailConfirmation: 'To finish changing your email address, we have sent an email to {email} simply click the link in the email to complete the process.',
  emailWasChanged: 'Your new email address has been confirmed',
  emailChanged: 'Email change confirmed',
  saveChanges: 'Save changes',
  deleteProfile: 'Delete profile',
  changeButton: 'Change',
  pendingButton: 'Pending',
  goBack: 'Go Back',
  edit: 'Edit',
  editComment: 'Edit comment',
  removeComment: 'Remove comment?',
  monitorSite: 'Monitor site',
  block: 'Block',
  loginPageDescription: 'World Database of Key Biodiversity Areas',
  loginBottomImageDescription: 'Honduras Spikethumb Frog (Plectrohyla dasypus) © Andrew Snyder / Re:wild',
  addNewCoProposer: 'Add new co-proposer',
  inviteCoProposers: 'Invite co-proposers',
  enterSitename: 'Enter site name',
  sendInvites: 'Send invites',
  pleaseEnterCurrentPassword: 'Please enter current password',
  manage: 'Manage',
  remove: 'Remove',
  about: 'About',
  nameAndLocation: 'Name & location',
  nameAndLocationDescription: 'Name and location of the site',
  assessment: 'Assessment',
  invite: 'Invite',
  manageUsers: 'Manage users',
  categoryDropdownPlaceholder: 'Category',
  draft: 'Draft',
  submitProposal: 'Propose assessment',
  submitEvaluation: 'Submit evaluation',
  yourSiteProposalIsInDraft: 'Your assessment is in Draft status and has not been proposed',
  totalUsers: 'Total users',
  siteProposalHasBeenSuccessfully: 'Site proposal has been successfully saved as draft',
  inviteCoProposersModalTitle: 'Invite Co-Proposers',
  enteredEmailAlreadyInUse: 'This email is already in registered in WDKBA',
  profileSuccessfullySaved: 'Your profile has been successfully updated',
  nominate: 'Nominate',
  nominateSite: 'Nominate assessment',
  nominateSiteText: 'Are you sure you want to nominate the proposed assessment in site {siteName}?',
  confirmAssessmentBtn: 'Confirm assessment',
  confirmAssessment: 'Confirm assessment?',
  confirmAssessmentText: 'Are you sure you want to confirm this nominated assessment for {siteName}?',
  approveEditsText: 'Are you sure that you want to submit the changes made to {siteName}? This action cannot be undone and your edits will be submitted for approval.',
  rejectBtn: 'Reject',
  rejected: 'Reject',
  delistBtn: 'Delist',
  delist: 'Delist',
  doesNotQualify: 'Does Not Qualify',
  setDoesNotQualify: 'Assign Does Not Qualify status',
  delistAssessment: 'Delist site?',
  doesNotQualifyModal: 'Does Not Qualify assessment?',
  doesNotQualifyText: 'Are you sure you want to change site status for {siteName} to Does Not Qualify? This operation cannot be undone.',
  rejectAssessmentBtn: 'Reject assessment',
  rejectAssessment: 'Reject assessment?',
  rejectEdits: 'Reject edits?',
  delistAssessmentText: 'Are you sure you want to delist this site: {siteName}?',
  rejectAssessmentText: 'Are you sure you want to reject the assessment for {siteName}? The assessment will be returned to draft status and the Proposer will be notified. Please ensure that comments have been provided that reflect the changes needed.',
  rejectEditsText: 'Are you sure you want to delete the edits made to {siteName}? This action can not be undone and the details will revert to those approved during the the last assessment or edit session.',
  nominateAssesment: 'Nominate assessment?',
  approve: 'Approve',
  approveForNomination: 'Approve for nomination?',
  approveForNominationText: 'Are you sure you want to approve the proposed assessment {siteName} for nomination?',
  manageUser: 'Manage user',
  decline: 'Decline',
  discardChanges: 'Discard changes?',
  yesCancel: 'Yes, cancel',
  returnToDraft: 'Return to Draft',
  returnToEditOnly: 'Reject edits',
  returnDraft: 'Return to Draft?',
  declineFeedback: 'Feedback',
  declineAssessment: 'Return feedback?',
  returnFeedbackText: 'Are you sure you want to return the proposed assessment {siteName} seeking further clarification and/ or details? Please ensure that your reasons are clearly presented in your review comments.',
  returnDiscardChangesText: 'Are you sure you want to discard the reassessment for {specieName}? All of your changes will be discarded and the former assessment of this species will be reinstated.',
  returnDiscardEcosystemChangesText: 'Are you sure you want to discard the reassessment for {ecosystemName}? All of your changes will be discarded and the former assessment of this ecosystem will be reinstated.',
  categoryName: 'Name',
  organization: 'Organization',
  userType: 'User type',
  status: 'Status',
  viewSite: 'View site',
  viewAll: 'View all',
  pending: 'Pending',
  passwordHasExpired: 'Password has expired',
  currentPassword: 'Current password',
  youHaveToChangePassword: 'Please change your password - uou will not be able to access the system until your password is changed',
  enterYourPassword: 'Enter your password',
  confirmNewPasswordEmpty: 'Please confirm your password',
  threatenedBiodiversity: 'Threatened biodiversity',
  geographicallyRestrictedBiodiversity: 'Geographically restricted biodiversity',
  ecologicalIntegrity: 'Ecological integrity',
  irreplaceabilityThroughQuantitiveAnalysis: 'Irreplaceability through quantitative analysis',
  biologicalProcesses: 'Biological processes',
  nameContactDetails: 'Name, Contact Details',
  provideReviewersInfoWhoCanCommentOnYourProposal: 'Provide details of reviewers who may be able to comment on this assessment (their names and contact details)',
  restrictedRangeStatus: 'Restr. range status',
  criteria: 'IUCN Red List criteria',
  redListCrit: 'Red List Crit.',
  aboutPageTitle: 'About proposal',
  aboutPageSubTitle: 'KBA criteria assessed',
  ongoingConservationActionsAtSite: 'Ongoing conservation actions at site',
  aboutProposalHint: 'Indicate the criteria that you are applying at the site, even if the site did not meet all of these . If you are applying Criterion E please contact the KBA Secretariat [hyperlink to info@keybiodiversityareas.org] for details about what is required.',
  monitoringPageTitle: 'Monitoring',
  noSpeciesMatchFilteringCriteria: 'No sites match filtering criteria',
  nationalSiteName: 'Enter national site name',
  internationalSiteName: 'Enter international site name',
  stateProvince: 'State or Province (if applicable)',
  stateProvincePlaceholder: 'Enter state or province',
  siteArea: 'Site area (km2)',
  siteAreaPlaceholder: 'Enter site area (in km2)',
  latitude: 'Latitude (dec. degrees)',
  latitudePlaceholder: 'Enter latitude of centroid (in decimal degrees)',
  longitude: 'Longitude (dec. degrees)',
  longitudePlaceholder: 'Enter longitude of centroid (in decimal degrees)',
  coveredByPa: 'Coverage by PA (% calculated based on WDPA)',
  coveredByPaTemplate: 'Coverage by PA (% band)',
  coveredByOECMTemplate: 'Coverage by OECM (% band)',
  supersededSitesDesription: 'Details about KBAs that will replaced by others',
  coveredByPaPlaceholder: 'Enter value for % covered by PA',
  reviewersContactsThatCanComment: 'Reviewers who may be able to comment on this assessment',
  coveredByPaHint: '% covered by Protected Areas as calculated from an overlap with PAs defined on the WDPA {hyperLink}',
  coverageArea: 'Coverage by OECMs',
  coveredByOECM: 'Coverage by OECMs (% calculated based on WDPA)',
  coveredByOECMPlaceholder: 'Value for % covered by OECMs',
  coveredByOECMHint: '% covered by Other Effective Area Conservation Measures (OECMs) as calculated from an overlap with OECMs on the WDPA {hyperLink}',
  habitatsLand: 'Habitats & land use',
  habitatsLandDescription: 'Habitats and land use regimes',
  pressures: 'Pressures',
  pressuresDescription: 'Details about pressures and threats',
  additionalDetails: 'Additional details',
  additionalDetailsDescription: 'Additional details relating the site',
  threats: 'Pressures',
  threatsDescription: 'Pressures description',
  threatsDescriptionTemplate: 'Description of pressures and threats at the site',
  threatsDescriptionHint: 'Please provide a general description of the pressures and threats (those pressures that affect the biodiversity elements of importance at the site) at the site',
  threatsDescriptionPlaceholder: 'Describe the pressures and threats present at the site',
  lowestElevation: 'Lowest elevation (m)',
  lowestElevationPlaceholder: 'Enter lowest elevation in metres',
  highestElevation: 'Highest elevation (m)',
  highestElevationPlaceholder: 'Enter highest elevation in metres',
  uploadFile: 'Upload file',
  uploadFilePlaceholder: 'Upload GIS file',
  systemLargest: 'System largest',
  system2Largest: 'System (2nd largest)',
  system3Largest: 'System (3rd largest)',
  systemLargestPlaceholder: 'Select largest system',
  system: 'System',
  secondLargestSystemPlaceholder: 'Select 2nd largest system',
  thirdLargestSystemPlaceholder: 'Select 3rd largest system',
  smallestSystemPlaceholder: 'Select smallest system',
  rationale: 'Rationale (KBA identification)',
  rationalePlaceholder: 'Provide rationale for why this site is being proposed as a KBA',
  siteDescription: 'Site description',
  siteDescriptionPlaceholder: 'Enter detailed site description',
  manageability: 'Manageability',
  manageabilityFieldTemplate: 'How is the site managed or potentially manageable?',
  siteManagedPlaceholder: 'Describe how  the site is managed?',
  protectedConserved: 'Protected or Conserved areas',
  protectedConservedDescription: 'Extent of coverage of the site by protected or conserved areas',
  supersidedSites: 'Superseded sites',
  supersidedSitesHint: 'If you are creating a new site that is replacing one or more existing KBAs, e.g. if you are merging or splitting current KBAs, please list the KBA(s) that are being replaced - they will become superseded when your site is confirmed',
  supersidedSitesPlaceholder: 'List any existing KBAs that are being replaced by your new site',
  delineation: 'Delineation',
  delineationRationale: 'Please provide an explanation of how the site was delineated',
  delineationPlaceholder: 'Please provide an explanation of how the site was delineated',
  siteCoverage: 'Coverage by PA',
  siteCoveragePlaceholder: 'Select % band',
  protectedArea: 'PAs and/ or OECMs covered',
  protectedAreaPlaceholder: 'List all PAs and/ or OECMs covered by KBA',
  biodiversityValues: 'Biodiversity values',
  biodiversityValuesPlaceholder: 'List any additional species or ecosystems that occur at the site',
  siteValues: 'Site values',
  siteValuesPlaceholder: 'List any indigenous groups that hold customary rights at the site and describe resources',
  landUse: 'Land use',
  landUsePlaceholder: 'Describe land use regimes at site',
  habitatDescription: 'General habitats description',
  sensitiveAtSiteLabel: 'Sensitive Species',
  sensitiveAtSiteSource: 'Provide more details about species sensitivity at this site',
  sensitiveAtSiteSourcePlaceholder: 'Describe the reasons why this species should be treated as sensitive at this site',
  sensitiveAtSiteSourceRequired: 'Source is required when "Sensitive at Site" is enabled',
  sensitiveAtSiteHint: "This species should be treated sensitive at this site",
  habitatDescriptionTemplate: 'Habitats description, where possible using the IUCN habitat classification',
  habitatPlaceholder: 'Describe the habitats present',
  habitatHint: 'Please provide a general description of the habitats present - this will be published on the KBA Factsheets.',
  notes: 'Additional information',
  notesTemplate: 'Any other details relating to the site',
  notesPlaceholder: 'Provide any other information relating to the site',
  references: 'References',
  referencesTemplate: 'References relating to the assessment (and/ or site)',
  referencesPlaceholder: 'Provide details of sources of information (citations, URLs, links to reports)',
  referencesHint: 'Provide details of sources of information (citations, URLs, links to reports) that relate to this site',
  siteName: 'Site name (International)',
  natureOfOccurence: 'Nature of occurence',
  ibaRelated: 'Other IBA-related criteria conditions',
  siteNameEnglishHint: 'Give an English-language name recognised for the site',
  siteNameNationalHint: 'Give a national name for the site',
  countryHint: 'Select country or countries from list and click Apply',
  stateProvinceHint: 'Indicate state or province in the country where this site occurs, if applicable',
  siteAreaHint: 'Area of proposed site (km2) - if measuring from the shapefile it must be projected using Cylindrical Equal Area projections and WGS84 datum',
  latitudeOfCentroidHint: 'Provide centroid of latitude - in decimal degrees with WGS84 datum',
  longitudeOfCentroidHint: 'Provide centroid of Longitude - in decimal degrees with WGS84 datum',
  lowestElevationHint: 'Give elevation in meters',
  highestElevationHint: 'Give elevation in meters',
  altitudeOfBathymetryHint: '',
  uploadFileHint: 'You must attach a boundary file for new or revised KBA boundaries. Existing ones with no change do not need a new file.',
  systemHint: 'Select the system type that best reflects the trigger elements for which the site qualifies. For example, if the site only support fish species that are restricted to the freshwater parts of the site select Freshwater, if the site also supports a dragonfly trigger that relies also on terrestrial habitats then add terrestrial as a separate selection (e.g. in the next system box (2nd largest etc.)',
  rationaleHint: 'Write a text account here of the rationale for why the site is proposed as a KBA. This text will be included in site fact sheets. In the case of redelineation of an existing KBA, the text in this field can be brief and standardised, but it needs to be appropriate for publication on the WDKBA and in IBAT. Apart from “KBA”, please spell out any acronyms used in the fields included in the factsheets on first mention for each site. ',
  siteDescriptionHint: 'Write a text account about the site - main habitats, altitude range, where it occurs and anything it is known for - this text will appear on the fact sheets found on the WDKBA. Each factsheet should stand alone, even if this means duplicating some text across sites. Please avoid cross-references to text in other sites (e.g., “see factsheet for XXX KBA”), as that text may get updated in the future and we cannot track cross-references. If a site is being reassessed and there are no changes you can indicate that this text remains as before.',
  siteManagedHint: 'Write a text account of why you believe the site to be manageable as a single unit - this text will appear on the fact sheets found on the WDKBA',
  delineationHint: 'For all new sites or existing KBAs with a new or revised proposed polygon, please provide an explanation of how the site was delineated. This can be brief and fairly standardised. If site delineation is aligned with the national boundary or an existing protected area, please provide a reference for the spatial data source (e.g., GADM, WDPA) and the name of the protected area. (It will not always be obvious from the KBA name if the KBA is smaller or larger.)',
  siteCoverageHint: 'Select % band that best reflects extent of site coverage by PA',
  biodiversityValueHint: 'List any additional species or ecosystems that occur at the site and give additional value to the site',
  siteValueHint: 'Indicate if the site includes land, water or other resources belonging to indigenous people or subject to customary use rights. Please list any indigenous groups that hold customary rights at the site',
  landUseHint: 'How is the land currently managed at the site?',
  notesHint: 'Provide any other information relating to the site',
  protectedAreaHint: 'List the Protected Areas and/ or OECMs covering the site together with their WDPA ID number(s) available from Protected Planet',
  notification: 'Notifications',
  expand: 'Expand',
  collapse: 'Collapse',
  system2ndLargest: 'System 2nd largest',
  system3rdLargest: 'System 3rd largest',
  systemSmallest: 'System smallest',
  congregatoryGroup: 'Congregatory group',
  ecoRegion: 'Ecoregion',
  searchEcoRegionName: 'Search Ecoregion name',
  ecoRegionHint: 'Provide details of your ecological integrity assessment here – please provide your accompanying report directly to your Regional Focal Point {hyperLink}',
  criterionC: 'Ecological integrity',
  criterionCSubTittle: 'Details of ecological integrity assessment at site',
  irreplaceability: 'Irreplaceability',
  irreplaceabilitySubTittle: 'Details of irreplaceability at the site',
  irreplaceabilityHint: 'Please contact your RFP and the KBA Secretariat directly with your irreplaceability assessment documentation. Once the assessment has been approved you may check the box below to indicate that your irreplaceability assessment has been approved and this site meets KBA Criterion E',
  enterIrreplaceabilityScore: 'Enter irreplaceability score',
  irreplaceabilityScore: 'Irreplaceability score',
  irreplaceabilityScoreHint: 'Please enter your irreplaceability score',
  enterAssessmentDate: 'Enter assessment year',
  irreplaceabilityAssessmentDateHint: 'Please enter the year of the assessment',
  checkboxIrreplaceability: 'Irreplaceability assessment approved, site meets Criterion E',
  irreplaceabilityCheckboxHint: 'Check the box when your irreplaceability assessment has been reviewed and approved by the RFP and KBA Secretariat',
  irreplaceabilityCheckboxLabel: 'Irreplaceability assessment',
  irreplaceabilityAssessmentDateLabel: 'Assessment year',
  ecoRegionSite: 'Number of sites',
  enterNumberOfCriterionCSites: 'How many sites meet Criterion C for this ecoregion?',
  assessmentDate: 'Year of ecological integrity assessment',
  assessmentDateEx: 'Provide year of assessment',
  assessmentDateEco: 'Year of ecosystem data',
  assessmentDateEcoPlaceholder: 'Provide year of ecosystem data',
  enterEvidenceForLowHumanImpact: 'Provide evidence for low human impact',
  enterEvidenceForIntactEcologicalCommunities: 'Provide evidence for intact ecological communities',
  criteriaAssessed: 'Criteria assessed',
  ecosystemName: 'Ecosystem name',
  yearMinToolTip: "Enter earliest year of the data",
  yearMaxToolTip: "Enter latest year of the data",
  seasonToolTip: "Select season",
  ecosystemCodeNumber: 'Code number',
  ecosystemCategory: 'IUCN Red List of Ecosystems category',
  ecosystemGlobalExtent: 'Global extent (km2)',
  ecosystemExtent: 'Minimum extent at site (km2)',
  ecosystemExtentBest: 'Best estimate of extent at site (km2)',
  ecosystemExtentMax: 'Maximum extent at site (km2)',
  ecosystemDataTable: 'Ecosystems',
  ecosystemDataTableSubTitle: 'Ecosystems triggering KBA criteria',
  ecosystemDataTableHint: '',
  otherCriteriaDataTable: 'Other criteria',
  otherCriteriaDataTableDescription: 'Criterion C or Criterion E assessment at site',
  source: 'Source',
  sourceGlobal: 'Source (global estimates)',
  enterEcosystemName: 'Provide a name for the ecosystem',
  codeNumberEx: 'E.g 00005',
  selectEcosystemCategory: 'Select IUCN Red List of Ecosystems category',
  enterGlobalExtent: 'Enter best estimate of global extent',
  enterSiteMinExtent: 'Enter minimum extent at site (if available)',
  enterSiteBestEstimateExtent: 'Enter best estimate of extent at site',
  enterSiteMaxExtent: 'Enter maximum extent at site (if available)',
  enterSourceOfEcosystemData: 'Provide details about the source of the ecosystem data',
  ecosystemData: 'Ecosystem Data',
  ecosystemSubTittle: 'Details for ecosystems assessed at the site',
  commentsPlaceholder: 'Provide your feedback here...',
  newEcosystem: 'New Ecosystem',
  collapseGroup: 'Collapse group',
  commentsHint: 'Select a new category or an existing discussion thread below and provide your comments',
  commentsTextArea: 'Comment text area',
  comments: 'Comments',
  leaveComment: 'Comment',
  expandGroup: 'Expand group',
  ecoRegionSiteHint: 'How many other sites have been shown to meet Criterion C in this ecoregion?',
  ecoIntegrityHuman: 'Give a text description that justifies the site has low human impact',
  ecoIntegrityIntact: 'Give a text description that justifies that the site has intact ecological communities',
  assessmentDateHint: 'Year that the assessment of ecological integrity was made. If using data that are prior to the actual assessment year then indicate the year of the data.',
  speciesDetailsForm: 'Species',
  speciesDetails: 'Species',
  speciesAtSite: 'Species at site',
  speciesDetailsSubTittle: 'Details for species assessed at the site',
  searchByScientificName: 'Search by Scientific name...',
  addSpecies: 'Add species',
  ecoIntegrityLowHumanImpact: 'Evidence for low human impact',
  ecoIntegrityEvidenceForIntact: 'Evidence for intact ecological communities',
  speciesList: 'Your species selection',
  speciesAssessment: 'Species assessment',
  removeSpecies: 'Remove species?',
  removeEcosystem: 'Remove this assessment?',
  yesRemove: 'Yes, Remove',
  ecosystemNameHint: 'Provide a name for the ecosystem',
  iucnMemberHint: 'Please indicate which group(s)?',
  kbaPartnerHint: 'Do you represent one or more KBA Partner organisation(s)?',
  ecosystemCodeNumberHint: 'Complete this section if assessing the site against ecosystems criteria A2 or B4. If known put the WDKBA ecosystem code here. Put the ecosystem element at the site on a new row - do not put it on the same row as a species element',
  ecosystemCategoryHint: 'Give Red List Category from Red List of Ecosystems',
  ecosystemGlobalExtentHint: 'Global area of ecosystem - measure using standard projection of Cylindrical Equal Area and WGS84 (km2)',
  ecosystemExtentHint: 'Provide minimum area of ecosystem in site (in km2) - measure using standard projection of Cylindrical Equal Area and WGS84',
  ecosystemExtentBestHint: 'Provide best area of ecosystem in site (in km2) - measure using standard projection of Cylindrical Equal Area and WGS84. If only min and max extent are available please provide an estimate of best as the midpoint of min and max extent',
  ecosystemExtentMaxHint: 'Provide maximum area of ecosystem in site (in km2) - measure using standard projection of Cylindrical Equal Area and WGS84',
  ecosystemAssessmentDateHint: 'Year that the assessment was made - if based on imagery then this should be year of the image (further details may be provided in the Source field below',
  acknowledgementText: 'Managed by BirdLife International on behalf of the KBA Partnership, and developed with generous support from the Garfield Weston Foundation and Bezos Earth Fund, and also from The Marks Family Charitable Trust, RSPB and other Donors.',
  ecosystemSourceHint: 'Provide further details about the source(s) of global and site data used',
  scientificName: 'Scientific name',
  noteLabel: 'Additional details (site estimates)',
  commonName: 'Common name',
  taxonomicGroup: 'Taxonomic group',
  taxonId: 'Taxon ID',
  taxonid: 'TaxonID',
  isTaxonomicGroupPrepopulated: 'Is Taxonomic group prepopulated?',
  phylumName: 'Phylum',
  className: 'Class',
  orderName: 'Order',
  familyName: 'Family',
  category: 'IUCN Red List category',
  rangeRestricted: 'Range-restricted',
  rangeRestrictedHint: 'Specifies if the species is range-restricted as described for Criterion B2 in the KBA Standard, and for some species is season specific. Species that lack Global IUCN Red List Assessments will not be recognized as range-restricted - please contact the KBA Secretariat {mailTo} if you have any queries about the classification assigned to this species.',
  possiblyExtinct: 'Possibly Extinct',
  determined: 'Determined',
  ecoBioRegionRestricted: 'Ecoregion/Bioregion-restricted',
  ecoRegionNameMap: 'Ecoregion and map',
  ecoRegionNameMapPlaceholder: ' ',
  bioRegionNameMap: 'Bioregion and map',
  bioRegionNameMapPlaceholder: ' ',
  assessmentSystem: 'Assessment system',
  evidence: 'Evidence of presence',
  unitsNumber: 'Min. no. reproductive units (RUs)',
  comprised: 'Define 10 RUs for this species',
  enterSpeciesCommonName: 'Enter species Common name',
  enterSpeciesTaxonomicGroup: 'Enter species Taxonomic group',
  selectSpeciesRedListCategory: 'Select species Red list category',
  selectEquivalentSystem: 'Select equivalent system',
  selectSpeciesRedListCriteria: 'Select species Red list criteria',
  rangeRestrictionDeterminedBy: 'Range restriction determined by',
  enterEcoRegionName: 'Enter Ecoregion name',
  enterEcoRegionMapUsed: 'Select Ecoregion map used',
  enterBioRegionName: 'Enter Bioregion name',
  enterBioRegionMapUsed: 'Select Bioregion map used',
  speciesRedListHint: 'If this species lacks a Global IUCN Red List Assessment and the IUCN Red List category is blank, please select a Red List category that matches your system most closely, and provide further details in the "Equivalent system used" field below',
  equivalentSystemHint: 'Please provide details about the equivalent assessment system used, and list the equivalences used for CR, EN and VU',
  determinedHint: '',
  ecoBioRegionRestrictedHint: 'Specifies if the species is ecoregion-restricted or bioregion-restricted as described for subcriteria B3a and B3b in the KBA Standard. Species that lack Global IUCN Red List Assessments will not be recognised as ecoregion or bioregion-restricted - please contact the KBA Secretariat {mailTo} if you have any queries about the classification assigned to this species.',
  // ecoRegionNameHint:,
  // ecoRegionMapHint:,
  evidenceHint: 'What evidence do you have that confirms the species is present at the site? If based on expert opinion give name and e-mail contact of expert (ensure they are willing to share contact details)',
  yearSpeciesDetailsHint: 'Most recent year for evidence of presence',
  unitsNumberHint: 'Please enter the minimum number of reproductive units present at the site. This is an essential field for assessing Criteria A1 (except A1e), B1, B3b and E. See KBA Guidelines for more details',
  comprisedHint: 'This field is to help interpret the reported number of RUs at the site. Different species have different reproductive strategies so 10 RUs will be expressed differently. Some examples of clear definitions of 10 RUs are: “Pair-bonding species: 10 pairs of males and females.” “Pair-bonding species: 10 males and 10 females.“ “10 active nests.” “Harem style mating system: 1 or more males and 10 females.”  “This species of moss is so tightly packed, that 10 RUs can be assumed to be present in 5 sq m”',
  speciesDetailsSourceHint: 'Please provide information on the source of the RU data provided - what evidence do you have that the site holds the minimum number of reproductive units you have entered and that the species is present, and include any sources (e.g. reference to a book, paper, report, url).  What is the year of the RU estimate? If based on expert opinion give name and e-mail contact of expert (ensure they are willing to share contact details) and year the expert saw the RUs.',
  parameterHint: 'Please review the available data at a site at global and local levels for this species, and decide which assessment parameter provides the best indication of the proportion of the global population size to use (further guidance can be found in Section 3.1 of the KBA Guidelines). You may assess this species using additional assessment parameters (if applicable) and/ or in multiple seasons.',
  minGlobal: 'Min. Global',
  bestGlobal: 'Best Global',
  bestGlobalEstimate: 'Global estimate (best)',
  maxGlobal: 'Max. Global',
  newReportTitle: 'Create new report',
  newReportSubTitle: 'Click on the filter panel button below to proceed',
  filterPannel: 'Filter Panel',
  enterRegionalMin: 'Enter minimum regional estimate',
  enterRegionalBest: 'Enter best regional estimate ',
  enterRegionalMax: 'Enter maximum regional estimate',
  regionalMin: 'Regional (min)',
  regionalBest: 'Regional (best)',
  regionalMax: 'Regional (max)',
  regionalEstimate: 'Source (regional estimates)',
  euPopulation: 'EU estimate',
  nationalPopulation: 'National estimate',
  euEstimate: 'Source (EU estimate)',
  nationalEstimate: 'Source (national estimate)',
  enterSpeciesMinGlobalData: 'Enter minimum global estimate',
  enterSpeciesBestGlobalData: 'Enter best global estimate',
  enterSpeciesMaxGlobalData: 'Enter maximum global estimate',
  enterRegionalEstimate: 'Enter regional estimates',
  enterEuPopulation: 'Enter EU population estimate',
  enterNationalPopulation: 'Enter national population estimate',
  enterEuEstimate: 'Enter EU estimate',
  enterNationalEstimate: 'Enter national estimate',
  enterSpeciesGlobalSourceData: 'Describe the source of the global estimates',
  enterNotesOnSpeciesGlobalData: 'Please provide any other details relevant to these global estimates',
  bestGlobalHint: 'If you only have one global value, please enter it in the “Best” field. If you only have a minimum and maximum, then please enter the mid-point of these in the “Best” field. Units should match those of the selected assessment parameter.',
  maxGlobalHint: 'Please enter the maximum global estimate (if available) based on the assessment parameter selected. Units should match those of the selected assessment parameter.',
  minGlobalHint: 'Please enter the minimum global estimate (if available) based on the assessment parameter selected. Units should match those of the selected assessment parameter.',
  globalDataSourceHint: 'If you are providing global estimates, please provide a source (including a link where available/ relevant) for these estimates (e.g. reference to a book, paper, report, url).',
  globalDataNoteHint: 'Please provide any other details relevant to these global estimates',
  regionalMinHint: 'Provide minimum estimate for the regional, biogeographic or other distinct population of this species',
  regionalBestHint: 'A best estimate must be provided for this assessment. Provide best estimate for the regional, biogeographic or other distinct population of this species',
  regionalMaxHint: 'Provide maximum estimate for the regional, biogeographic or other distinct population of this species',
  regionalEstimateHint: 'Provide details about the source of the estimates provided for the regional, biogeographic or other distinct population',
  euPopulationHint: 'Provide an estimate of the population size of this species occurring in the EU',
  nationalPopulationHint: 'Provide an estimate of the population size of this species occurring in the country',
  euEstimateHint: 'Provide details about the source of the EU estimate provided',
  nationalEstimateHint: 'Provide details about the source of the national estimate provided',
  minSite: 'Min. Site',
  bestSite: 'Best Site',
  maxSite: ' Max. Site',
  derivation: 'Derivation of estimate',
  enterSpeciesMinSiteData: 'Enter minimum site estimate',
  enterSpeciesBestSiteData: 'Enter best site estimate',
  enterSpeciesMaxSiteData: 'Enter maximum site estimate',
  enterSpeciesSiteSourceData: 'Describe the source(s) of the site estimates',
  derivationOfEstimate: 'Derivation of estimate',
  yearOfSitePopulationEstimates: 'Provide year(s) of estimate(s) given (e.g. 2018-2020)',
  enterNotesOnSpeciesSiteData: 'Please provide any other details relevant to these site estimates',
  minSiteHint: 'Please enter the minimum site estimate (if available) based on the assessment parameter selected. Units should match those of the selected assessment parameter.',
  bestSiteHint: 'If you only have one site value, please enter it in the “Best” field. If you only have a minimum and maximum, then please enter the mid-point of these in the “Best” field. Units should match those of the selected assessment parameter.',
  maxSiteHint: 'Please enter the maximum site estimate (if available) based on the assessment parameter selected. Units should match those of the selected assessment parameter',
  siteSourceHint: 'Please provide a source for the site data that you have entered (e.g. reference to a book, paper, report, url). If the data are taken from a Red List assessment, please give link to Red List assessment',
  derivationHint: 'Please indicate how the "Best (site)" estimate was derived',
  siteYearHint: '',
  siteNoteHint: 'Add any additional notes here relating to the species data at the site, and/ or to explain why you are proposing any of the selections that you have made',
  occupiedHabitat: ' Occupied habitat',
  globallyMostImportant5OccupiedHabitat: 'Provide information about any available sources supporting your selection',
  triggerLabel: 'Reason(s) why species does not qualify',
  triggerCongregationLabel: "Reason(s) why congregation no longer qualifies",
  triggerEcosystemLabel: 'Reason(s) why ecosystem no longer qualifies',
  triggerLabelHint: 'If this trigger no longer meets KBA criteria please indicate why. First you must de-select the ‘Qualifies’ checkbox and thereafter you may select any reason that applies from the dropdown menu.',
  reasonForSelectionDCriteria: 'Reason for selection D criteria',
  aggregation: 'Aggregations',
  justification: 'Justification (Criterion D, aggregations)',
  justificationThatTheSpeciesIsAggregated: 'Provide justification for your selected options',
  largestAggregationHint: 'This field is specifically for species that aggregate and that could trigger Criterion D: please describe how the species is aggregatory (relevant for D1); provide justification that the site holds a significant proportion of the global distribution of the species during periods of environmental stress (relevant for D2); or provide justification showing that the site is a recruitment source (relevant for D3). If applying D1b, justify how the site is among the largest 10 aggregations known for the species and provide details about the other 9 sites',
  refugium: 'Refugium',
  recruitment: 'Recruitment',
  kbaAssessment:"KBA assessment",
  season: 'Season',
  specieTriggerPlaceholder: 'If this species no longer qualifies — please select all reason(s)',
  selectMultipleOptions: 'You may select multiple options, and click Apply',
  congregationTriggerPlaceholder: 'If this congregation no longer qualifies — please select all reason(s',
  ecosystemTriggerPlaceholder: 'If this ecosystem no longer qualifies — please select all reason(s',
  criterionCTriggerPlaceholder: 'If this ecological integrity no longer qualifies — please select all reason(s',
  criterionETriggerPlaceholder: 'If this irreplaceability no longer qualifies — please select all reason(s',
  selectSeasonalDistributionAppliedTo: 'Select seasonal distribution applied to',
  aggregationCriteriaHint: 'Please carefully choose which of the statements relating to the nature of the species occurrence at this site apply. These statements help inform the criteria met - e.g. you will need to specify that the species forms aggregations and/ or it is regularly occurring (to meet relevant criteria)',
  occupiedHabitatHint: 'Is this site part of the globally most important 5% of occupied habitat for this species AND you want to apply subcriterion B3c? If so, select "Yes". If not, use the default setting. See KBA Guidelines section 2.6. Please also submit information with proposal about all sites known which also meet this 5%',
  sourceHabitatHint: 'Please provide a source for the Justification you have entered for aggregations (e.g. reference to a book, paper, report, url). If based on expert opinion give name and e-mail contact of expert (ensure they are willing to share contact details).',
  reasonHint: '',
  seasonHint: 'If applying the estimate to a particular seasonal distribution (eg. breeding or non breeding), or to a migratory stop-over point, please select the relevant season here.',
  evidenceTheSpeciesIsPresentAtTheSite: 'Evidence that the trigger is present',
  yearForWitchThereIsEvidence: 'Most recent year for evidence of presence',
  minNumberOfReproductiveUnitsRuAtSite: 'Min. number of reproductive units (RU) at site',
  SpeciesCriteriaTriggered: 'KBA criteria',
  userId: 'User ID',
  assessmentYear: 'Assessment year',
  kbaTriggered: 'KBA criteria triggered',
  largestSystem: 'Largest system at site',
  highEcological: 'Ecoregion with high ecological integrity at site',
  sourceReproductiveUnits: 'Source of RU data',
  whatAre10RusComprisedOf: 'What are 10 RUs for this trigger?',
  yearPresence: 'Year (presence)',
  sourceOfRuData: 'Source of RU data',
  sourceOfReproductiveUnitDataIncludingYear: 'Provide information about the source of RU data',
  assessmentParameterApplied: 'Assessment parameter applied',
  parameter: 'Assessment parameter',
  finishEditing: 'Finish editing',
  cancelReassessment: 'Cancel reassessment?',
  cancelEcosystemReassessment: 'Cancel ecosystem reassessment?',
  globalData: 'Global Estimates',
  siteSpeciesData: 'Site Estimates',
  regNatEstimates: 'Regional and National Estimates',
  siteEstimate: 'Site estimate (Best)',
  newParameter: 'New Parameter',
  aggregations: 'Aggregations',
  pleaseContactTheKBASecretariatForAnyDataConcerns: 'Please complete all assessment details relating to "{specieName}"',
  speciesDetailSubTittle: 'Species Details',
  speciesDetailSubTittleHint: 'Please select species or contact the KBA Secretariat if your species is not listed {mailTo}',
  ecosystemSubTitle: 'Ecosystem Data',
  ecosystemSubTitleHint: 'Complete this section if assessing the site against ecosystems criteria A2 or B4',
  speciesAssessmentSubTittle: 'Details about the species at global and site level',
  speciesAssessmentSubTittleHint: 'Please select parameter',
  totalSites: 'Total sites',
  mySites: 'My sites {mySitesNumber}',
  totalReports: 'Total reports',
  organisation: 'Organisation',
  levelOne: 'Level one',
  levelTwo: 'Level two',
  levelThree: 'Level three',
  timing: 'Timing',
  selectLevelThreeThreat: 'Select a level three option',
  selectLevelTwoThreat: 'Select a level two option',
  selectLevelOneThreat: 'Select a level one option',
  newThreat: 'Add new pressure',
  levelOneThreatsHint: 'Select a pressure (and subsequent levels as prompted) and provide details about its timing',
  levelTwoThreatsHint: 'Select a pressure (and subsequent levels as prompted) and provide details about its timing',
  levelThreeThreatsHint: 'Select a pressure and provide details about its timing',
  threatsHint: 'Document the pressures at this site and select the most relevant timing for each. Further details about their impacts on the biodiversity elements of importance may be provided in the KBA monitoring section',
  selectThreatLevelTiming: 'Select the timing of this pressure',
  // selectTriggerSpeciesSubtitle: 'Select the trigger species for which this pressure applies',
  selectTriggerEcosystemSubtitle: 'Select the trigger ecosystem for which this pressure applies',
  chooseThreats: 'Review pressures and their timings',
  whatThreatsAreYouAssessingForThisSite: 'Select the triggers to add State assessment details',
  action: 'Conservation actions',
  whatActionsAreAssessingForThisSite: 'What actions are ongoing or needed at this site?',
  timingThreatsHint: 'Select the timing of this pressure',
  threatsAndAction: 'Pressures and Actions',
  removeModal: 'Are you sure you want to permanently remove this comment?',
  removeModalText: 'Are you sure you want to remove {name} from the list? This action\n cannot be undone.',
  optional: 'Optional',
  uploadGisFiles: 'Upload Gis files',
  chooseFile: 'Upload file',
  fileSizeIsTooBig: 'File size is too big',
  taxonGroup: 'Taxon group',
  iucnStatus: 'Red List Cat.',
  reproductiveUnits: 'RUs (Min)',
  population: '% in site',
  criteriaKba: 'Criteria met',
  ibaCriterias: 'IBA criteria',
  calculationsSubTittle: 'Species triggering criteria',
  pleaseCompleteThisField: 'Please complete this field',
  removeThreat: 'Remove pressure',
  reviewers: 'Reviewers',
  review: 'Review',
  commentsLabel: 'Comments',
  iucnMember: 'IUCN Member',
  iucnMemberLabel: 'IUCN Member',
  iucnMemberPlaceholder: 'List any IUCN Specialist Groups that you are a member of',
  listToComplete: 'Please complete the following fields',
  validation: 'Validation',
  siteDetails: 'Site details',
  predefined: 'Predefined',
  ecosystems: 'Ecosystems',
  ecosystemsAtSite: 'Ecosystems at site',
  ecosystemRedListCat: 'IUCN Red List of Ecosystems category',
  ecosystemGlobalExtentBest: 'Ecosystem site extent (Best estimate)',
  ecosystemKbaTriggered: 'Ecosystem KBA criteria triggered',
  speciesGlobal: 'Species Global',
  siteDetailsDescription: 'Further details about the site and its biodiversity',
  manageabilityDelineation: 'Manageability & Delineation',
  manageabilityDelineationDescription: 'Further details about site manageability and delineation of the boundary',
  fieldNamename: 'Site name',
  fieldNamesiteNameNational: 'National site name',
  fieldNamecountry: 'Country',
  fieldNamesiteArea: 'Site area (km2)',
  fieldNamelatitudeOfMidPoint: 'Latitude (dec. degrees)',
  fieldNamelongitudeOfMidPoint: 'Longitude (dec. degrees)',
  fieldNamelowestAltitude: 'Lowest elevation (m)',
  fieldNamehighestAltitude: 'Highest altitude',
  minimumDepth: 'Minimum depth (m)',
  minimumDepthHint: 'Provide minimum depth in meters; depth values should be positive',
  minimumDepthPlaceholder: 'Enter minimum depth in meters',
  maximumDepth: 'Maximum depth (m)',
  maximumDepthHint: 'Provide maximum depth in meters; depth values should be positive',
  maximumDepthPlaceholder: 'Enter maximum depth in meters',
  fieldNameAltitudeOfBathymetryId: '',
  fieldNameEcoSystemsId: 'System largest',
  fieldNamerationaleForSiteInformation: 'Rationale',
  fieldNamesiteDescription: 'Site description',
  fieldNamehowIsTheSiteManaged: 'Site managed',
  fieldNamedeliniationRationale: 'Delineation',
  fieldNameCoverageOfProtectedAreasId: 'Site coverage',
  fieldNameEcologicalIntegrityEcoRegionId: 'Ecoregion',
  fieldNamenumberOfCriterionSitesInEcoRegion: 'Ecoregion site',
  fieldNameevidenceOfLowHumanImpact: 'Eco integrity - Low Human impact',
  fieldNameevidenceForIntactEcologicalCommunities: 'Eco integrity - ecological communities',
  proposed: 'Proposed',
  inviteReviewers: 'Invite reviewers',
  supersede: 'Supersede',
  commentBox: 'Comments {commentNumber}',
  changeStatus: 'Change status',
  revertToConfirmed: 'Change to Confirmed',
  changeStatusToConfirmFromSupersede: 'Are you sure you want to change the site {name} status from Superseded to Confirmed?',
  fieldNamedateOfAssesment: 'Assessment date',
  unfinishedProposal: 'Further details are required',
  continueEditing: 'Continue editing',
  confirm: 'Confirm',
  incompleteFields: 'Incomplete fields',
  oecmOverlapPlaceholder: 'Select % band',
  oecmDropHint: 'Select % band that best reflects coverage by OECMs',
  siteId: 'Site ID',
  SiteId: 'SiteID',
  autoSave: 'Autosaved',
  saving: 'Saving changes',
  backToSites: 'Back to Sites',
  coProposers: 'Co-Proposers',
  draftSiteMessage: 'Your assessment is in Draft status and has not been proposed',
  proposedSiteMessage: 'This site is now Proposed and is ready for review by the RFP',
  nominatedSiteMessage: 'This site is now Nominated and is ready for review by the KBA Secretariat',
  nominateAssessment: 'Nominate assessment?',
  nominated: 'Nominated',
  reviewedByRFP: 'This site is now has been reviewed and can be Nominated by the Proposer',
  feedback: 'Feedback',
  returnFeedback: 'Return feedback?',
  confirmed: 'Confirmed',
  rejectSpecies: 'Reject species',
  confirmSpecies: 'Confirm species',
  siteProposal: 'Site Proposal',
  approveSite: 'Approve assessment',
  approveEditOnlySite: 'Approve Edits',
  reviewEditOnlySite: 'Review Edits',
  confirmEcosystem: 'Confirm ecosystem',
  rejectEcosystem: 'Reject ecosystem',
  'editOnly': 'Edit Only',
  'draftSiteStatusHint': 'Site is in Draft',
  'proposedSiteStatusHint': 'Site was proposed',
  'nominatedSiteStatusHint': 'Site was nominated',
  'reviewedSiteStatusHint': 'Site was reviewed',
  'confirmedSiteStatusHint': 'Site was confirmed',
  'supersededSiteStatusHint': 'Site was superseded',
  'editSiteStatusHint': 'Site in edit mode',
  noSpeciesSelected: 'No species selected',
  noEcosystemsSelected: 'No ecosystems assessed',
  reassess: 'Reassess',
  ecologicalIntegrityData: 'Ecological Integrity Data',
  newTriggers: 'New triggers',
  siteReassessment: 'Assessment',
  continueReassess: 'Continue Reassess',
  justificationNoChange: 'Additional details where no changes made to estimates',
  existingTriggers: 'Existing triggers',
  nonQualifying: 'Non qualifying',
  qualifies: 'Qualifies',
  lastTimeReassessed: 'Date of last assessment',
  qualificationReasonHint: 'Please provide additional information relating to the reassessment of this biodiversity element where no changes were made to the estimates, or type N/A. If the trigger element no longer qualifies, please use this space to provide more details if required. If you are  inferring that its extent, distribution and/ or abundance is unchanged or improved based on some other evidence, then please provide further details and preferably include a source to justify this.',
  delisted: 'Delisted',
  details: 'Details',
  justificationNoChangeEcoSystemPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an ecosystem or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCongregationPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting a congregation or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionCPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion C or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionEPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion E or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  siteCriteria: 'Criteria',
  justificationNoChangeSpeciePlaceholder: 'Please provide justification if you are not providing updated site estimates - e.g. if you are delisting an ecosystem or if you are inferring that the species distribution and abundance is unchanged based on some other evidence',
  natureOfOccurrence: 'Nature of occurrence',
  localTermsUpdatedOn: 'Updated on —',
  localTerms: 'Terms of use',
  dateUpdatedOn: '20 February 2022',
  termsPageTitle: 'Terms and conditions of use',
  termsPageSubTitle: 'The World Database of Key Biodiversity Areas Terms and Use',
  introductionLabel: 'Introduction',
  introductionSubText: 'The World Database of Key Biodiversity Areas (WDKBA) has been developed by BirdLife International on behalf of the KBA Partnership . It provides a tool to support individuals, organisations and KBA National Coordination Groups to propose sites as KBAs, document and delineate them, and reassess them to keep information up to date, in order to support conservation of the most important sites for nature worldwide. It enables management of data on KBAs nationally, regionally and globally, including sites identified as Important Bird and Biodiversity Areas and by the Alliance for Zero Extinction. It also facilitates provision of data on important sites for biodiversity to governments, the private sector (via the {linkTo}), and other stakeholders, in order to promote their protection, conservation and safeguard.',
  tableOfContents: 'Table of Contents',
  generalLabel: '1. General',
  generalSubText1: 'The Terms and Conditions (here after ‘Terms’) outlined below relate to data entered into The World Database of Key Biodiversity Areas (WDKBA) by users, including:',
  generalBullet1: 'All tabular, numeric, textual or spatial (and associated attribute) data relating to KBAs',
  generalBullet2: 'Data entered to assess a new site or to reassess an existing KBA',
  generalBullet3: 'Data relating to the biodiversity importance of a site, physical or socio-political attributes of a site, or as part of a monitoring assessment of a site',
  generalBullet4: 'Data relating to Draft, Proposed, Nominated or Confirmed assessments',
  generalBullet5: 'Data entered directly into the WDKBA web portal, via any batch upload facility, or via any associated tools (e.g. for submitting or editing spatial or other data on site boundaries)',
  generalBullet6: 'Data on existing KBAs that have been imported into the WDKBA at the time of its launch, and any data entered or modified subsequently',
  generalSubText2: 'The Terms take effect from the point at which you accept these Terms and Conditions. From time to time, these Terms may be modified. Accordingly, please review the Terms when alerted, since any use by you after any such modifications or additions shall be governed by these Terms as modified. These Terms shall over-ride any other restrictions placed on data you enter into the WDKBA. By agreeing to these Terms, you also agree to follow the procedures outlined in the {linkTo2}. Any data downloaded from the WDKBA are subject to the {linkTo}, which among other restrictions, do not permit reposting, redistribution or commercial use.',
  intelectualLabel: '2. Intellectual Property and Ownership',
  intelectualSubText1: 'You confirm that you have the right to submit any data entered into the WDKBA, and that by doing so you are not infringing the rights of any third party. Users and/or their institutions (and licensors, if any) retain the intellectual property relating to any data they enter into the WDKBA, and grant {linkTo}, as managers of the WDKBA on behalf of the Key Biodiversity Areas (KBA) Partnership, a perpetual, world-wide, non-transferable license (with the right to sub-license) to use these data (in their original format, either whole or in part, alone or combined with other data), subject to clause 5 on Sensitive data, without requesting prior permission, for conservation purposes, including:',
  intelectualBullet1: 'Reposting on the KBA website {linkTo}',
  intelectualBullet2: 'Providing to other public websites and online platforms, including those of individual KBA Partners',
  intelectualBullet3: 'Providing to third parties for conservation, research, education and other non-commercial purposes',
  intelectualBullet4: 'Use in research, communications, advocacy and policy applications',
  intelectualBullet5: 'Licensing for commercial use through the {linkTo} (IBAT), either by making the data available directly on IBAT or via third parties, with income generated used to support KBA identification, data management, or conservation. For the purposes of these Terms, ‘commercial use’ means a) any use by, on behalf of, or to inform or assist the activities of, a commercial entity (an entity that operates ‘for profit’) or b) use by any individual or non-profit entity for the purposes of revenue generation.',
  intelectualSubText2: 'These purposes may be met through disseminating these data through any means, including on websites, mobile applications, through web services, KML files, file transfer protocols, email, electronic media or devices, publications, and social media etc. Where KBA data are presented on the KBA website, WDKBA users who are the Proposers or Co-Proposers of each site will be acknowledged as such on the relevant KBA factsheets, in order to recognise their contributions. These acknowledgments shall be applied from 2022 onwards.',
  importantBirdLabel: '3. Important Bird and Biodiversity Area Data',
  importantBirdSubText: 'Users of the WDKBA representing BirdLife Partners also grant to BirdLife International a non-transferable license to use data on bird-triggered sites (‘Important Bird and Biodiversity Areas; IBAs), in their original format, either whole or in part, alone or combined with other data, without requesting prior permission, for conservation purposes, including all those listed in clause 3, as well as reposting on the BirdLife website Data Zone. This license applies to data on existing IBAs imported into WDKBA at the time of its launch (consistent with clause (a) under Information Sharing and Data in the BirdLife Operational Procedures), and any data on bird-triggered sites entered or modified subsequently. This license will remain valid even if the institution subsequently leaves or is excluded from the BirdLife Partnership.',
  sensitiveDataLabel: '4. Sensitive Data',
  sensitiveDataSubText: 'Any assessments of biodiversity elements flagged by users as Sensitive using the relevant field in the database will be treated as outlined in the {linkTo1}, and not published on the {linkTo2}.',
  privacyLabel: '5. Privacy',
  privacySubText: 'As managers of the WDKBA, BirdLife International is committed to protecting your personal information and privacy BirdLife International will collect and process your personal data through your use of the WDKBA in accordance with its {linkTo}. It is important that you read this policy so that you are fully aware of how and why we are using your data. This privacy policy supplements other notices and privacy policies and is not intended to override them. Note that by registering as a user in WDKBA, this enables: (a) other users to invite you to input to reassessment of any biodiversity elements at a site for which you were the Proposer, (b) other users to invite you as a Co-Proposer of a site, and (c) Regional Focal Points or the KBA Secretariat to invite you as a Reviewer of a site proposal. These invitations may be sent via notifications within the WDKBA itself, and as emails to the address you provide when you register.',
  disclaimerLabel: '6. Disclaimer on Frontiers and National Boundaries',
  disclaimerSubText: 'The designation of geographical entities in the WDKBA and associated tools does not imply the expression of, or represent, any opinion by the KBA Partners concerning the legal status of any country, territory or area, or concerning the delimitation of its frontiers or boundaries.',
  disclaimerOfWarrantyLabel: '7. Disclaimer of Warranty Limitations on Liability',
  disclaimerOfWarrantySubText: 'Neither BirdLife International nor the other KBA Partners or their affiliates, or any of their respective employees, agents, third-party content providers, or licensors warrant that access to and use of the WDKBA will be free from interruptions or free from errors, nor that any data downloaded or exported from it are free of viruses, worms, or other harmful components; no warranty is made as to the results that may be obtained from use of the WDKBA, or as to the accuracy, reliability, or content of any information extracted from it. Data downloaded from the WDKBA are provided without any warranties of any kind, either express or implied, including but not limited to warranties of title or fitness for a particular purpose. To the fullest extent permitted by law, in no event shall BirdLife International or other KBA Partners be liable for any indirect, incidental or consequential damages arising out of any use of, or inability to use, KBA data or the WDKBA or that result from mistakes, omissions, interruptions, deletions, errors, or defects in the KBA data, or delays in the operation, transmission or failure of performance of the WDKBA, even if BirdLife International or other KBA Partners were previously advised of the possibility of such damages, or for any other claim by you or any other person.',
  indemnificationLabel: '8. Indemnification',
  indemnificationSubText: 'You agree to defend, indemnify and hold BirdLife International and other KBA Partners and their affiliates harmless from any and all damages, liabilities, costs and expenses, including attorneys fees, related to any violation of these Terms by you or any authorized users of your account.',
  terminationLabel: '9. Termination',
  terminationSubText: 'BirdLife International, on behalf of the KBA Partnership, may suspend or terminate your use of the WDKBA at any time, effective immediately, with or without prior notice, if we judge that your use of the WDKBA compromises its security or integrity, or is incompatible with the aims of the {linkTo}. This automatically terminates your license to use any KBA data downloaded from the WDKBA.',
  changeManagementLabel: '10. Change in management of the WDKBA',
  changeManagementSubText: 'If BirdLife International leaves the KBA Partnership and management of the WDKBA is taken over by another KBA Partner, the permissions granted here in will be automatically transferred to that KBA Partner, except for those in clause 3 which will remain with BirdLife International.',
  governingLawLabel: '11. Governing Law Disputes',
  governingLawSubText: 'These Terms and all non-contractual or other obligations arising out of or in connection with them are governed by English law. Any dispute arising out of or connected in any way with these Terms shall be referred to the jurisdiction of the English courts.',
  miscellaneousLabel: '12. Miscellaneous',
  miscellaneousSubText: 'The provisions of these Terms shall inure to the benefit of BirdLife International and other KBA Partners and their third-party content providers and licensors. No waiver by any party hereto of any of the provisions hereof or of any breach or other default hereunder shall be deemed to be a waiver of any preceding or subsequent breach or default.',
  contactLabel: '13. Contact information',
  contactSubText: 'If you have any questions about any of these Terms or how they may apply to your intended use of WDKBA and the KBA data it contains, please contact {mailTo}',
  minYearPlaceholder: 'Earliest year of the dataset',
  earliestYear: 'Earliest year (Site estimate)',
  minYear: 'Year (min)',
  minYearTooltip: 'Please provide the earliest year of the dataset for this species. If the assessment is based on area-based parameters, please indicate the year of dataset being used to calculate % cover',
  maxYear: 'Year (max)',
  maxYearTooltip: 'Please provide the last year of the dataset for this species. If the assessment is based on area-based parameters, please indicate the year of dataset being used to calculate % cover',
  maxYearPlaceholder: 'Last year of the dataset',
  dismiss: 'Dismiss',
  cookies: 'Cookies',
  acceptCookies: 'Accept Cookies',
  cookiesBody: 'By clicking the Accept Cookies button,\n' + 'you understand and consent to the use of cookies in accordance with our {hyperLink}',
  deleteDraft: 'Delete draft?',
  deleteEditSiteOnly: 'Delete Edit Only Site ?',
  siteForDeletingBody: 'Are you sure you want to permanently\n' + 'delete the draft assessment for {siteName}? This action cannot be undone.',
  editSiteForDeletingBody: 'Are you sure you want to delete the edits made to {siteName}? This action can not be undone and the details will revert to those approved during the the last assessment.',
  yesDelete: 'Yes, Delete',
  deleteDraftBtn: 'Delete draft',
  cookieSettings: 'Cookie Settings',
  assess: 'Assess',
  reports: 'My reports',
  download: 'Download',
  view: 'View',
  sensitiveSpecies: 'Sensitive site approval',
  sensitiveSpeciesVisibilityStatus: 'Visibility status',
  sensitiveSpeciesStatusPending: 'Pending',
  sensitiveSpeciesStatusApproved: 'Approved',
  sensitiveSpeciesStatusRejected: 'Rejected',
  sensitiveSpeciesRevoke: 'Reject',
  sensitiveSpeciesRejectAction: 'Reject',
  sensitiveSpeciesAlreadyApproved: 'This site has already been approved.',
  sensitiveSpeciesAlreadyRejected: 'This site has already been rejected.',
  '/reports': 'My site reports',
  createReport: 'Create report for my sites',
  filters: 'Filters',
  downloadAll: 'Download all',
  overview: 'Overview',
  filtersPanel: 'Filter Panel',
  filtersApplied: 'Filter(s) applied',
  runReport: 'Run report',
  monitoringSites: 'Monitoring evaluation',
  siteFilters: 'Site filters',
  speciesFilters: 'Species filters',
  ecosystemFilters: 'Ecosystem filters',
  ecologicalFilters: 'Ecological integrity filters',
  otherFilters: 'Other filters',
  region: 'Region',
  globalKbaCriteria: 'Global KBA criteria',
  assessmentDateFilter: 'Assessment year',
  selectRegion: 'Select region',
  selectCountry: 'Select your country',
  selectSystem: 'Select system',
  selectThreat: 'Select pressure',
  selectAssessmentStatus: 'Select assessment status',
  selectKbaStatus: 'Select KBA status',
  selectKbaClassification: 'Select KBA classification',
  selectGlobalKbaCriteria: 'Select global KBA criteria',
  selectAssessmentDate: 'Select assessment year',
  selectEcosystem: 'Select ecosystem',
  selectEcosystemRedListCategory: 'Select Ecosystem Red List Category',
  selectEcoregion: 'Select ecoregion',
  ecoregion: 'Ecoregion',
  ecoregionBioregionRestricted: 'Ecoregion / Bioregion restricted',
  ecosystemRedListCategory: 'Ecosystem Red List Category',
  // species: 'Species',
  backToReports: 'Back to Reports',
  factsheet: 'Factsheet',
  id: 'Id',
  RedListCategoryCode: 'IUCN Red List Category',
  specieName: 'Common name',
  IUCNRedListCriteria: 'IUCN Red list criteria',
  equivalentSystemIfNotRedList: 'Equivalent system if not IUCN Red List',
  EcoBioRegionRestrictedId: 'Eco Bio-Region restricted Id',
  paramId: 'Parameter Id',
  SiteAssessmentParameterTypeId: 'Assessment parameter',
  earliestDataSetYear: 'Earliest year (site estimate)',
  minReproductiveUnits: 'Reproductive units (Min.)',
  ruSource: 'Reproductive units (Source)',
  kbaCriterias: 'Species KBA criteria triggered',
  publishedYear: 'Published year',
  isRedListCategoryCodePrepopulated: 'Is IUCN Red List category prepopulated ?',
  ecoregions: 'Ecoregions',
  bioregions: 'Bioregions',
  SeasonalDistributionId: 'Season Id',
  sourceGlobalData: 'Global estimate (source)',
  latestDataSetYear: 'Latest data set year',
  DerivationOfEstimateId: 'Derivation of site estimate Id',
  sourceOfData: 'Site estimate (source)',
  ruCompromisedOf: 'Reproductive units (what are 10 comprised of)',
  createdAt: 'Site created at',
  speciesPresenceEvidence: 'Evidence that species is present at site',
  yearPresenceEvidence: 'Most recent yr for evidence of presence',
  regularlyHeld: 'Regularly held',
  regularlyOccurring: 'Regularly occurring',
  regularlyHeldRestricted: 'Regularly held restricted',
  globallyMostImportant: 'Globally most important',
  aggregationPredictability: 'Aggregation predictability',
  aggregationsAsCriteria: 'Aggregations as criteria',
  recruitmentSource: 'Recruitment source',
  treatment: 'Current taxonomic treatment',
  siteAreaCalculated: 'Site area (km2)',
  latitudeOfMidPointCalculated: 'Latitude (dec. degrees)',
  longitudeOfMidPointCalculated: 'Longitude (dec. degrees)',
  lowestAltitude: '',
  highestAltitude: '',
  thisSpecieAlreadyAddedToSiteAssesment: 'This species is already listed in the assesment',
  calculatedProtectedArea: 'Site % area of covered by protected areas/OECMs (calculated)',
  minDepth: '',
  maxDepth: '',
  SiteStatusId: 'KBA Status Id',
  SiteDetailsCountryId: 'Site details country id',
  siteCode: 'Site code',
  rationaleForSiteInformation: 'Rationale for site nomination',
  howIsTheSiteManaged: 'Site management',
  deliniationRationale: 'Site delination rationale',
  CoverageOfProtectedAreasId: 'Site % area of covered by protected areas (user estimated)',
  additionalBiodiversityValues: 'List any additional species or ecosystems that occur at the site',
  indigenousGroups: 'Site ownership by indigenous peoples',
  indigenousGroupsTemplate: 'Site values (indigenous people or customary use rights)',
  landUseRegimesAtSite: 'Site land use',
  landUseRegimesAtSiteTemplate: 'Land-use regimes at site',
  EcoSystemsId: 'Largest system at site Id',
  EcoSystems2LargestId: '2nd largest system at site',
  EcoSystems3LargestId: '3rd largest sysetm at site',
  EcoSystemsSmallestId: 'Smallest system at site',
  EcologicalIntegrityEcoRegionId: 'Ecoregion with high ecological integrity at site',
  evidenceOfLowHumanImpact: 'Evidence of low human impact at site',
  evidenceForIntactEcologicalCommunities: 'Evidence for intact ecological communities at site',
  dateOfAssesment: 'Ecological integrity site assessment date',
  ecoregionEcologicalIntegrity: 'Ecoregion ecological integrity',
  secondLargestSystem: 'Second largest system',
  thirdLargestSystem: 'Third largest system',
  smallestSystem: 'Smallest system',
  historyId: 'History Id',
  importData: 'Import data',
  browseFile: 'Browse File',
  orDragACSVFileHere: 'or drag a CSV file here (30MB max. size)',
  downloadCSVTemplates: 'Download CSV templates',
  validateFile: 'Validating your file...',
  fileValidated: 'File successfully validated',
  important: 'Important',
  downloadCSVFile: 'Download errors file',
  uploadNewFile: 'Upload updated file',
  importModalErrorBannerText: 'Please download the errors file (link below) which indicates the specific records (row number) and fields that need to be addressed. Here, there are {count} error/s listed. Amend these fields in the original CSV file and upload it again.',
  validationFailed: 'Validation failed',
  importingYourData: 'Importing your data',
  siteAttributes: 'Site attributes',
  assessmentSpecies: 'Assessment species',
  threatsAndActions: 'Pressures and Actions',
  dropFileToAttach: 'Drop file to upload',
  removeFileText: 'Are you sure you want to permanently\n' + 'remove {title} from the uploaded files? This action cannot be undone.',
  'removeFile?': 'Remove file?',
  noResultsToShow: 'No results to show',
  threatsId: 'Threats ID',
  yearMinPlaceholder: 'Earliest year of the dataset',
  yearMaxPlaceholder: 'Last year of the dataset',
  yearMin: 'Year (min)',
  yearMax: 'Year (max)',
  seasonId: 'Season ID',
  rejectedTriggers: 'Rejected Triggers',
  approvedTriggers: 'Approved Triggers',
  permanentTooltipDefaultBody: 'Please note that importing the CSV file will append the existing site data',
  permanentTooltipDefaultTitle: 'Important',
  reportLoadingScreenTitle: 'Building report',
  runningReport: 'Your report is running, please wait...',
  buildingReport: 'Please wait, this may take some time...',
  permanentTooltipDefaultFooter: 'Ok, Understood',
  congregationSpeciesGroup: 'Species group',
  congregationSpeciesGroupPlaceholder: 'Select congregatory group',
  minCongregationEstimate: 'Minimum estimate (mature individuals)',
  minCongregationPlaceholder: 'Enter minimum estimate in mature individuals',
  bestCongregationEstimate: 'Best estimate (mature individuals)',
  bestCongregationPlaceholder: 'Enter best estimate in mature individuals',
  maxCongregationEstimate: 'Maximum estimate (mature individuals)',
  maxCongregationPlaceholder: 'Enter maximum estimate in mature individuals',
  detailsCongregationLabel: 'Additional details',
  detailsCongregationPlaceholder: 'Please provide additional details, such as information about the source of the estimates',
  congregationTitle: 'Multi-species congregations',
  congregationSubTitle: 'Select a species group and provide assessment details',
  addNewCongregation: 'New congregation',
  newCongregationTitle: 'New congregation',
  removeCongregations: 'Remove congregation?',
  removeCongregationModalBody: 'Are you sure you want to permanently remove {name} from the list? This action can not be\n' + ' undone.',
  fileImportError: 'File structure or field names should not be amended',
  congregationTable: 'Congregations',
  congregationDataTableSubTitle: 'Site triggered by IBA congregation criteria',
  noCongregationSelected: 'No congregation selected',
  speciesGroup: 'Species group',
  estimateBest: 'Estimate (best)',
  biodiversityKnowledgeHolders: 'Biodiversity knowledge-holders',
  uploadSiteFiles: 'Upload supporting material',
  uploadSiteFilesHint: 'Please upload any supporting material (word files, PDFs, excel files, spatial data etc.) that support this assessment (site or trigger element details). You should make it clear when naming the file(s) what part of the assessment they relate to (and/ or include a readme file if there are many). The total size of your files uploaded should not exceed 50MB.',
  biodiversityKnowledgeHoldersPlaceholder: ' Describe your consultations with, and please list, any biodiversity knowledge-holders relating to this assessment',
  biodiversityKnowledgeHoldersHint: 'Describe your consultations with, and please list, any biodiversity knowledge-holders relating to this assessment, which may include international/local scientists, government and other biodiversity knowledge-holders.',
  previousProposers: 'Previous proposers',
  previousProposersPlaceholder: 'Please describe your consultations with any previous proposers of assessments relating to this KBA',
  previousProposersHint: ' If you are modifying site details or the boundary of an existing KBA please describe your consultations with any previous proposers of assessments relating to this KBA, especially documenting discussions relating to boundary amendments and resolutions. If no changes are being made, please state “No consultations because this proposal doesn’t alter an existing KBA.',
  government: 'Government',
  governmentPlaceholder: 'Describe your consultation with relevant government authorities',
  governmentHint: ' Your local and/ or national Government should be aware of your KBA assessments – describe your consultation with relevant government authorities, including those associated with the biodiversity knowledge consultations above. This may be presentation of the KBAs in a workshop at which government was present, or specific meetings about the site',
  customaryLegalRightsHolders: 'Customary or legal rights-holders',
  customaryLegalRightsHoldersPlaceholder: 'Describe any consultations with Customary or legal rights-holders',
  customaryLegalRightsHoldersHint: 'Describe any consultations with Customary or legal rights-holders',
  contributors: 'Contributors',
  contributorsPlaceholder: 'List people’s names/ institution, in a format that can be made public on the KBA website',
  contributorsHint: 'Please list people’s names and if relevant their institution, in a format that can be made public on the KBA website; contributors should be informed at the outset that their contributions will be acknowledged in this way. Do not include additional details such as contact details, for data privacy reasons',
  searchSitePlaceholder: 'Search for a site by name or site ID',
  chooseHabitats: 'Habitats',
  whatHabitatsAreYouAssessingForThisSite: 'What habitats are present?',
  habitatsHint: 'Please select from the following pulldown menu the habitats that are present at this site and provide the percentage that habitat occupies within the site',
  levelOneHabitatsHint: 'Select the high level habitat',
  selectLevelOneHabitat: 'Select from level one options ',
  selectLevelTwoHabitat: 'Select from level two options',
  selectLevelThreeHabitat: 'Select from level three options',
  removeHabitat: 'Remove habitat',
  habitatsPercentage: '% in site',
  habitatsPercentagePlaceholder: 'Enter % of site habitat occupies',
  habitatsPercentageHint: 'Site Habitat Percentage',
  newHabitat: 'New Habitat',
  map: 'Map',
  loadingMap: 'Loading map...',
  siteBoundaryLayerTitle: 'Site Boundary',
  allKBAsLayerTitle: 'All Current KBAs',
  wdpaLayerTitle: 'WDPA Sites',
  wdpaPointLayerTitle: 'WDPA Points',
  wdpaPolygonLayerTitle: 'WDPA Polygons',
  siteBoundary: 'Site Boundary',
  siteBoundaryDescription: 'Site Boundary section Short Description',
  boundaryNotDefined: 'Boundary not yet defined',
  boundaryUnchanged: 'Site boundary is unchanged',
  updateBoundaryBySelecting: 'Define the site boundary by selecting features from layers:',
  updateBoundaryByDrawing: 'Or use the controls below to draw the site boundary on the map:',
  updateBoundaryByDrawingOrEditing: 'Or use the controls below to draw and edit the site boundary on the map:',
  invalidShapefileError: 'The uploaded file could not be processed. Please upload another file.',
  shapefileWithNoLayersError: 'No layers were found on the uploaded shapefile. Please upload another file.',
  fileFormatError: 'Please upload a .zip file',
  maxFileSizeError: 'The uploaded file must not exceed {megabytes}MB. Please upload another file.',
  boundaryOverlapsKBALayer: 'WARNING: Your proposed KBA boundary overlaps that of another existing KBA. While it may be submitted, please ensure that you have undertaken relevant consultations to try to resolve the overlapping area(s)',
  uploadKBAShpFileHint: 'Upload a zipped shapefile under 5MB.',
  addLayer: 'Add Layer',
  layerNamePlaceholder: 'Enter a name to show on the layer list',
  layerName: 'Layer Name',
  firstAddLayer: 'First upload a shapefile or add a layer...',
  selectFromLayers: 'Select From Layers',
  uploading: 'Uploading...',
  mapLayers: 'Map Layers',
  uploadShapefile: 'Upload Shapefile',
  selectFromLayersInstructions: 'Select features by clicking on the map or by using the table. CTRL + click/drag allows you to select multiple features quickly!',
  featuresSelected: 'Features selected',
  selectingFeatures: 'Selecting Features for {boundaryName}',
  useSelectedFeatures: 'Use Selected Features',
  layerSelectLabel: 'Layer to Select from',
  layerSelectPlaceholder: 'Select a layer with features for your boundary',
  featureTable: 'Feature Table',
  showingSelectedFeatures: 'Showing selected features',
  showingFeaturesOnScreen: 'Showing features on screen',
  replaceExistingBoundary: 'Replace existing boundary',
  zoomToLayer: 'Zoom to layer',
  selectBasemap: 'Select Basemap',
  increaseOpacity: 'Increase opacity',
  decreaseOpacity: 'Decrease opacity',
  delete: 'Delete',
  addFeatureService: 'Link to URL',
  layerUrl: 'URL',
  verifyUrl: 'Verify URL',
  layerUrlPlaceholder: 'Enter URL of feature service',
  selectedLayerOutOfRange: 'Selected layer is currently out of range.',
  selectedLayerNotVisible: 'Selected layer is not visible. Turn on in layer list to view.',
  layerVerified: 'Layer verified!',
  scaleField: 'Scale: 1 : {scale, number}',
  latitudeAndLongitudeFields: 'Latitude: {latitude}, Longitude: {longitude}',
  zoomToEditAction: 'Zoom and edit',
  zoomInToEdit: 'Zooming in to at least 1 : {scaleCutoff, number} is recommended to edit the current boundary.',
  editWithoutZooming: 'Edit without zooming',
  siteBoundaryNotEditable: 'Site boundary not editable',
  boundaryIsTooComplexAlertMessage: 'The selected boundary cannot be edited on screen. Click on the boundary for further instructions about replacing it.',
  boundaryIsTooComplexPopupMessage: 'The selected boundary cannot be edited on screen. If revisions are needed, a new boundary will need to be created locally and uploaded. To do so please first delete this boundary and then follow the usual steps for uploading a new (corrected) boundary.',
  mapView: 'Map View',
  tableView: 'Table View',
  showTable: 'Show table:',
  filterByName: 'Filter by Name:',
  filterByCountry: 'Filter by Country:',
  enterKBAName: 'Enter national name of KBA',
  superseded: 'Superseded',
  statuses: 'Statuses:',
  warningModalHeader: 'Species Not Recognised → This species is not recognised',
  warningModalExplanation: 'This species is not currently recognised - please select one or more of the non-qualifying options (including ‘Taxonomic revision’) before clicking reassess, and if you wish to reassess the current taxonomic version then add it as a new species from the main assessment window',
  continue: 'Continue',
  warningModalHeaderSpecies: 'This species is not recognised',
  nonQualifyReasonWarning:'Please select one or more of the non-qualifying options below before clicking reassess, or cancel your reassessment',
  assessmentParameter: 'Assessment parameter',
  proposalPurposeHint: 'Please indicate the purpose of your proposal by selecting one of the options below and be sure to provide additional detail in the open text box that follows. For assessments and reassessments, please review the requirements as set out in “Key Biodiversity Areas Proposal Process: Guidance on Proposing, Reviewing, Nominating and Confirming sites” available {hyperLink}, and during reassessments please review and revise as necessary all aspects of the proposal (site details, KBA boundary etc.). If you select one of the edit-only options, you are not undertaking an assessment or reassessment, but are just submitting corrections to the boundary or minor edits that do not necessitate a reassessment, such as correcting spelling mistakes. You will need to click propose once these changes are made. These edits will be reviewed by the RFP and KBA Secretariat, and if approved the date of assessment will not be updated.',
  proposalDetailsHint: 'Provide further details here, including a general summary of your proposal, e.g. mention the species/ groups you are assessing or disqualifying during a reassessment. If this is an edit-only assessment, please specify or summarise the details that you are amending',
  proposalPurposeLabel: 'Indicate the purpose of your proposal',
  proposalDetailsLabel: 'Provide details about the nature of your proposal',
  proposalDetailsPlaceholder: 'Provide further details about your proposal',
  proposalPurposePlaceholder: 'Select the purpose of your proposal',
  editNow: 'Edit Only',
  editOnlyStatus: 'Edit Only',
  submitEdits: 'Submit Edits',
  deleteEdits: 'Delete Edits',
  editOnlyMessage: 'By clicking "Continue", your assessment will be in “Edit-only” mode. This option permits edits to some fields in the “Site details” and “About” tabs, and does not constitute a reassessment. In the About tab, please provide your name and the list of fields that you are editing (or summarising the changes made if to many fields). Note that no other users can edit or reassess the site until you complete or cancel your edits. You can invite collaborators to contribute using the "Invite Co-Proposers" option. If you decide not to proceed, you can discard your edits at any time. Once your edits are finalized, submit them for review to complete the process.',
  reassessmentMessage:'By clicking Assess biodiversity you are initiating a reassessment and this site cannot be assessed by anyone else until you have completed the process (through to confirmed status). You can invite others to participatin the assessment through the invite co-proposers option. If you decide you do not wish to complete the reassessment, you can delete your draft assessment at any stage.',
  submit: 'Submit',
  approveEdits: 'Approve edits',
  bulkImportData: 'Bulk Import Data (Optional)',
  downloadTemplate: 'Download Template',
  orDragAxlsxFileHere: 'or drag a XLSX file here (30MB max. size)',
  apiKeysTitle: 'API Keys',
  generateApiKey: 'Generate API Key',
  bulkImportShapeFile: 'Bulk Import Shapefile (Optional)',
  browseShapeFile: 'Browse Shapefile',
  orDragAZipFileHere: 'or drag a ZIP file here (30MB max. size)',
  filesUploadedSuccessfully: 'Files uploaded successfully',
  confirmBulkReassessment: 'I confirm this Excel includes bulk reassessments',
  ignoreExistingHabitats: 'Ignore existing habitats',
  contributors_assessment: "Contributors to this assessment",
  contributorsAssessmentHint: "Document those who contributed to this particular assessment, including people’s names and if relevant their institution. Please make sure to add these contributors to the overall site contributors (Site details). Do not include contact details.",
  contributorsAssessmentPlaceholder: "Enter contributors to this assessment",
  speciesUploader: "Upload supporting documentation species assessments",
  speciesUploaderHint: "Please upload any documentation that supports species included in the identification of this KBA (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB. If you have many spatial files that you wish to provide please contact the KBA Secretariat. Once the KBA is confirmed this documentation will not be visible to WDKBA users.",
  uploadSupportingDocumentation: "Upload supporting documentation",
  uploadSupportingDocumentationHint: "Please upload any documentation that supports this KBA proposal (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB.",
  // sensitiveSpeciesWarningTitle: "Please note",
  // sensitiveSpeciesWarningBody: "Please ensure you explain clearly what species/ taxonomic groups you plan to reassess - it may be that some of the qualifying species at this site have been assigned sensitive and are not immediately visible to you as an individual proposer. If your taxonomic group(s) of interest includes this sensitive species the KBA Secretariat will be in touch about this.",
  sensitiveSpeciesSubmitted: "Your request to reassess this site has been received and will be processed shortly. Thank you for your patience.",
  sensitiveSpeciesAlreadySubmitted: "This has already been submitted.",
  sensitiveSpeciesSubmitError: "Failed to submit sensitive species data. Please try again.",
  submitting: "Submitting...",
  failedToLoadSensitiveSites: "Unable to load sensitive sites. Please try again.",
  sensitiveSiteApproved: "Sensitive site approval has been recorded successfully.",
  failedToApproveSensitiveSite: "Unable to approve this sensitive site. Please try again.",
  sensitiveSiteRejected: "Sensitive site approval has been rejected.",
  failedToRejectSensitiveSite: "Unable to reject this sensitive site. Please try again.",
  okay: "Okay",
  sensitiveSpeciesWarningTitle: "Sensitive Species Warning",
  sensitiveSpeciesWarningBody: "This site contains sensitive species. Please be aware that sensitive species data will not be published publicly.",
  //monitoring tab translations
  state: "State",
  pressure: "Pressure",
  response: "Response",
  guidanceandtools: "Guidance",
  selectStatePressureResponse: "Select State, Pressure and/or Response",
  monitoringEvaluation: "Monitoring evaluation",
  addMonitoringEvaluation: 'Add monitoring evaluation',
  editMonitoringEvaluation: 'Edit monitoring evaluation',
  editMonitoringRevaluation: 'Edit monitoring evaluation',
  reEvaluateMonitoring: 'Add monitoring evaluation',
  viewMonitoringEvaluation: 'View monitoring evaluation',
  monitoringAboutPageTitle: 'About monitoring evaluation',
  monitoringAboutPageSubTitle: 'What will this sub-heading be?',
  monitoringAboutProposalHint: 'Indicate the criteria that you are applying at the site, even if the site did not meet all of these.',
  evaluationTypeLabel: 'Which of State, Pressure and Response will you evaluate?',
  stateDataQualityPlaceholder: 'Indicate the quality of your state data',
  pressureDataQualityPlaceholder: 'Indicate the quality of your pressure data',
  responseDataQualityPlaceholder: 'Indicate the quality of your response data',
  stateDataQualityLabel: 'State data quality:',
  pressureDataQualityLabel: 'Pressure data quality:',
  responseDataQualityLabel: 'Response data quality:',
  monitoringEvaluationDateLabel: 'Monitoring evaluation date',
  monitoringEvaluationDatePlaceholder: 'Select monitoring evaluation date',
  stateDataQualityHint: 'Select the option that best reflects the quality of the data/ knowledge informing your state evaluation.',
  pressureDataQualityHint: 'Select the option that best reflects the quality of the data/ knowledge informing your pressure evaluation.',
  responseDataQualityHint: 'Select the option that best reflects the quality of the data/ knowledge informing your response evaluation.',
  additionalSiteFeedback: 'Additional site feedback',
  additionalSiteFeedbackPlaceholder: 'Please provide any additional feedback.',
  additionalSiteFeedbackHint: 'Please add any other comments that reflect how well you understand what is going on at the site overall – the trigger elements, pressures and the effectiveness of any actions.',
  provideAnyReferencesSources: 'Provide any references or other sources',
  provideAnyReferencesSourcesPlaceholder: 'References and sources that were used to inform this monitoring evaluation.',
  provideAnyReferencesSourcesHint: 'Provide details or references that were used to inform this monitoring evaluation.',
  uploadRelevantFiles: 'Upload relevant files',
  uploadRelevantFilesHint: 'Upload reports or other sources that were used to inform this monitoring evaluation.',
  anyOtherDetailsRelevance: 'Any other details of relevance',
  anyOtherDetailsRelevancePlaceholder: 'Provide any other details of relevance to this monitoring evaluation, e.g. a general description of how you approached the monitoring evaluation, and/ or any other feedback that you consider useful.',
  statePressureQualityOptions:'Select which of State, Pressure and Response you will evaluate (please try to evaluate all) – your selection will affect in subsequent tabs the detail available for completion. ',

// state tab
  stateTitle: "State evaluation",
  toolTipstateTitle:"The species and ecosystems of importance at this site are listed below and may be selected for assessment. You may select all triggers, or you may tick a selection of trigger elements. These triggers will form the basis of your state assessment and details must be completed for all that you select. You may adjust this selection as you progress.",
  stateSubHeading: "Select the biodiversity elements that you wish to monitor for state",
  stateEvaluationHint:'Indicate the nature of the state evaluation for this trigger by selecting one of the options below. If you can provide a current estimate for this trigger element please select the first option. If you do not have data that supports an updated estimate, you may indicate a change category.',
  selectBiodiversity: "Select biodiversity ",
  selectBiodiversityInfo: "Select the biodiversity elements which will form the basis of your state evaluation ",
  toolTipselectBiodiversity:"Select the trigger species and or ecosystem types from this KBA that reflect the state of the site and that you will monitor (or select “All”)",
  createStateEvaluation: "Add species",
  createStateEvaluationEcosystem: "Add ecosystem",
  viewStateEvaluation: "Open evaluation",
  selectState: "Select all",
  stateShowing: "Showing",
  add:"Add",
  evaluate:"Evaluate",
  stateBiodiversityTitle:"Biodiversity elements to be assessed for State",
  stateBiodiversitysub:"Select the biodiversity elements to add more evaluation details",
  triggers:"Triggers",
  triggersSub:"Select the triggers to add State assessment details",
  addMoreTrigger:"Add more triggers to state evaluation",
  benchmarkDetails:"Benchmark details",
  benchmarksubhead:"Benchmark details for the selected trigger element",
  benchmarktooltip:"Presented below is the biodiversity element that you have elected to provide state details for. The first section at the top of this panel shows the benchmark details, i.e. the baseline year (when the biodiversity element was first identified as a KBA trigger) and a benchmark estimate, which is an estimate that reflects the site-level population when first identified – the benchmark unit and estimate can be edited (see tooltips on relevant fields below). The section that follows requires you to provide either 1) an updated estimate or 2) a category that reflects the change in the site-level population since the baseline year. Further details are available in the tooltips below.",
  biodiversitytriggerElement:"Biodiversity trigger element",
  bioTaxonomicGroup:"Taxonomic group",
  bioNumberEvaluation:"Number of monitoring evaluation",
  bioEvaluation:"Select number of monitoring evaluation",
  bioBaselineYear:"Baseline year",
  bioMonitoringPerameter:"Monitoring parameter",
  bioBenchmarkValue:"Benchmark value",
  bioMonitoringPerameterToolTip:"If you are not using the trigger element’s original assessment parameter, define the parameter that you have elected to apply (e.g. number of nests, burrows, chicks hatched etc.). Ideally the same parameter should be used in subsequent evaluations.",
  bioBenchmarkValueToolTip:"If you are not using the estimate and assessment parameter used when this biodiversity element was first identified as a trigger for this site, provide an updated estimate here and define the parameter used below. Note this estimate should reflect the abundance (species)/ extent (ecosystem) for the baseline year.",
  bioSubTitle:"Details that inform the state of this trigger element at the site",
  natureOfTheStateEvaluation:"Define the nature of the state evaluation for this trigger",
  toolTipbenchmarkfield:"Indicate the nature of the state evaluation for this trigger by selecting one of the options below. You can either 1) provide a current estimate for this trigger element (first option), or 2) indicate the change category if you are not able to provide an updated estimate. Ideally this change category will be informed and supported by other factors such as, for example change in the extent of habitat availability (where the trigger is known to be influenced by the availability of suitable habitat), an assessment based on a representative sample of data from within the site. For ecosystem triggers, please also provide an assessment of condition based on the categories available in the dropdown menu. The questions that follow will relate specifically to the options selected.",
  changeGenuine:"Is the change genuine",
  toolTip2:"De-select if the state assessment provided for this trigger does not reflect a genuine change in its population/ extent/ condition, rather it is the result of some other factor, e.g. the accuracy of the estimate provided for the trigger has been improved because of improvements to the survey technique and analyses. In such circumstances, and where you are providing an updated estimate, then if you can also adjust the benchmark accordingly then genuine change is appropriate. You may provide more details about the assessments that do not reflect genuine change in ‘Any other details of relevance’ in the ‘About’ tab.",
  updateEstimate:"Provide an updated estimate",
  benchmarkValuefield3:"Provide an updated estimate to the benchmark value",
  tooltip3:"Provide an updated estimate based on the benchmark and parameter indicated above.",
  benchmarkfield4:"Provide further details to justify your selection",
  stateCategoryBestDescribes:"Indicate the state category that best describes the % remaining",
  toolTipbenchmarkfield5:"Indicate the state category below that best describes the % (of species population or ecosystem extent) of this trigger remaining relative to the benchmark.",
  stateCategoryEcosystem:"Indicate the state category that best describes the condition of this ecosystem trigger relative to the benchmark",
  toolTipbenchmarkfield6:"This question refers specifically to ecosystems and how condition has changed since relative to the benchmark, and the result may differ from extent above. Please provide further details below that are relevant to how ecosystem condition was measured and compared.",
  categoryInferring:"How was this category inferring state chosen?",
  toolTip7:"Provide more detail about the evidence that influenced your category selection(s) above, e.g. other indirect observations might have been based on systematic monitoring in the surrounding region/areas or elsewhere, or information about the change in one or more threats known to affect the trigger at the KBA.",
  furtherDetailsJustify:"Provide further details to justify your selection",
  toolTip8:"Provide any more details that are relevant to your category selection(s) above, e.g. for ecosystem condition please elaborate on how condition was measured and compared.",
  benchmarkCondition:"Benchmark condition",
  modalTitle:"Species state evaluation",
  backToSelection:"Back to selection",
  species:' Species',
  ecosystem:'Ecosystem',
  creating:'Adding...',
  addMoreSpecies:'Add species',
  addMoreEcosystems:'Add ecosystem',
//pressure tab
  pressureTitle: "Pressure evaluation",
  pressureSubHeading: "List the pressures affecting biodiversity at this site",
  pressureEvaluationHint:'List all of the pressures (threats) at the site that are deemed to affect the biodiversity elements triggering criteria, and select their timings (current, past, future etc.)',
  selectPressures: "Select Pressures",
  selectPressuresInfo: "Select the pressures which will form the basis of your pressure evaluation ",
  reviewPressureSelector: "Review pressures and their timings",
  reviewPressureSubtitle: "Select the triggers to add State assessment details",
  pressureInfoTooltip: "Provide monitoring details about the site",
  threatTitle:"Threat impacts on trigger element details",
  threatSubTitle:"How are trigger elements affected by the threats",
  threaInfoToolTip:"Indicate for each threat the trigger elements that are affected, and where possible identify the scope and severity of the threat on each trigger element impact.",
  selectTriggerSpceies:"Select trigger species",
  addDetailsEffect:"Add details of the effect",
  selected:'selected',
  // expand:"Expand",
  close:"Close",
  scopeOfThreat:"Scope of threat",
  severityOfThreat:"Severity of threat",
  threatTiming:"Timing",
  selectTriggerSpeciesSubtitle:"Select which to include and then click to 'Add to the evaluation'",
  selectTriggerSpeciesInfo:"Indicate for each threat the trigger elements that are affected, and where possible identify the scope and severity of the threat on each trigger element impact.",
  apply:"Apply",
  displaying:"Displaying",
  addDetails:"Add more details",
  selectAll:"Select all",
  addTriggersToEvaluationBtn:"Add to the evaluation",
  addEcosystemTriggersToEvaluationBtn:"Add to the evaluation",
  noRecordsFound:"No records found",
  selectTriggerEcosystemInfo:"Indicate for each threat the trigger elements that are affected, and where possible identify the scope and severity of the threat on each trigger element impact.",
  threatImpactTriggerTitle:"Threat impacts on trigger element details",
  threatImpactTriggerSubTitle:"How are trigger elements affected by the threats",
  addMoreTriggerBtnText: "Add {name}",
  threatTriggerSpecieSubTitle:"Select the options that best reflect the scope and severity of the threat",
  threatTriggerSpecieInfoTooltip:"Indicate for each threat the trigger elements that are affected, and where possible identify the scope and severity of the threat on each trigger element impact.",
  paste: "Paste",
  copy: "Copy",
  onlyForSelectedSpeciesTitle: "The following selections will ONLY be applied to this selected species",
  onlyForSelectedTaxonomicTitle: "The following selections will be applied to ALL species in this taxonomic class",
  onlyForSelectedTaxonomicInfo: "If all species within this taxonomic class are similarly affected (scope, severity and timing) by this threat, you may assign scope and severity categories here and they will be copied to all species in the class",
  ScopeOfThreatTitle: "Scope of threat",
  SeverityOfThreatTitle: "Severity of threat",
  TimingOfThreatTitle: "Timing of threat",
  pressureValidation: "Please complete all missing Pressure/Threat information before submitting the evaluation",
  taxonDeleteModalTitle: "Delete Confirmation",
  taxonDeleteModalMessage: "Do you want to delete class?",
  speciesDeleteModalMessage: "Do you want to delete species?",
  ecosystemDeleteModalMessage: "Do you want to delete ecosystem?",
  bulkDeleteModalTitle: "Bulk Delete Confirmation",
  bulkSpeciesDeleteModalMessage: "Do you want to delete selected species?",
  bulkEcosystemDeleteModalMessage: "Do you want to delete selected ecosystem?",
  bulkDeleteToasterConfirmationMessage: "Bulk delete completed successfully.",
  bulkDeleteToasterFailureMessage: "Failed to delete selected items.",
  pasteSuccessMessage: "Selected items paste successfully.",
  pasteFailureMessage: "Failed to delete selected items.",
  beforeNotSelectBulkItemMessage: "Please select items before deleting.",
  beforeNotSelectCopyPasteItemMessage: "Please select copy before pasting.",
  backToPressureBtnText: "Back to Pressures",
  triggerSpeciesNoSelectMessage: "Please select at least one item.",
  triggerEcosystemNoSelectMessage: "Please select at least one item.",
  addTriggerToThisEvaluationBtn: "Add triggers to this evaluation",
  noTriggerSelectedText: "No triggers selected, first",
  removeSpeciesModalText: 'Are you sure you want to remove {name} from the list? This action\n cannot be undone.',
  removeEcosystemModalText: 'Are you sure you want to remove {name} from the list? This action\n cannot be undone.',
  onlyForSelectedEcosystemTitle: "The following selections will ONLY be applied to this selected ecosystem",
  // onlyForSelectedSpeciesEcosystemTitle: "The following selections will ONLY be applied to this selected ecosystem",

  // Response tab
  responseTitle: "Response Evaluation",
  protectedAreas:'The band that reflects percentage of the site covered by protected areas (PA) has been pre-selected based on the value generated based on an overlap between the KBA layer and that of PAs in WDPA. If you consider the current % by protected areas is not accurately reflected, please undertake a parallel “Edit-only” assessment to make a change in the user-fed % PA cover value in the Site details tab.',
  conservationMeasures:'The band that reflects percentage of the site covered by Other Effected Area-based Conservation Measures (OECMs) has been pre-selected based on the value generated based on an overlap between the KBA layer and that of OECMs in WDPA. If you consider the current % by OECMs is not accurately reflected, please undertake a parallel “Edit-only” assessment to make a change in the user-fed % OECM cover value in the Site details tab.',
  managementPlanningInfo:'Select the option that best reflects the extent of management planning at this site.',
  responseEvaluationTitle: "Response evaluation (site conservation measures)",
  provideConservationDetails: "Provide details about conservation measures at the site",
  conservationActionTest: "Select the option that best reflects the conservation actions at this site.",
  coverageByProtectedAreas: "Coverage by Protected Areas",
  coverageByOecms: "Coverage by Other Effected Area-based Conservation Measures (OECMs)",
  conservationActionsUnderwayAndNeeded: "Conservation actions underway and needed",
  conservationActionsUnderwayAndNeededInfo: "List the conservation actions that are most needed and of relevance to the biodiversity trigger elements at this site. Please also indicate any that are underway. If information on conservation actions has been supplied as part of previous monitoring evaluations or previous assessments and reassessments then these will be listed – please review previously documented conservation actions of relevance to the biodiversity elements triggering criteria for this site (needed and/ or underway). Update this list by 1) selecting needed and/ or underway), 2) adding other actions that were not previously documented, or 3) deleting any that are no longer of relevance to the trigger elements.",
  provideMonitoringDetails: "Complete the following questions that relate to management planning and conservation actions taking place at the site, and provide details of the conservation measures underway and/ or needed at the site.",
  selectManagementPlanning: "Indicate the extent of management planning at the site",
  managementPlanningTitle: "Management Planning",
  selectConservationAction: "Indicate the extent of conservation actions at the site",
  conservationActionsTitle: "Conservation Actions",
  conservationActionsUnderway: "Conservation actions underway",
  conservationActionsNeeded:"Conservation actions needed at site",
  bulkAction: "Bulk Action",
  selectTiming: "Select Timing",
  deleteConservationActionSuccess:"Conservation Action deleted successfully",
  deleteConservationActionError:"Error deleting Conservation Action. Please try again",
  actionsLevel1:'Actions - Level 1',
  actionsLevel2:'Actions - Level 2',
  actionsLevel3:'Actions - Level 3',
  selectAction:'Select Action',
  monitoringForDeletingDraft: 'Are you sure you want to permanently\n' + 'delete this draft? This action cannot be undone.',
  editmonitoringForDeletingBody: 'Are you sure you want to permanently\n' + 'remove this monitoring from the list? This action cannot be undone.',
  assessments:'Assessments',
  biodiversityEvaluations:'Biodiversity Evaluations',
  // allBiodiversityEvaluations:'All evaluations {assessmentsNumber}',
  noBiodiversityEvaluations:'All evaluations (0)',
  furtherDetails:'Provide further details that explain your conservation actions selections above',
  furtherDetailsPlaceholder:'Please provide further details',
  noReassessmentHistory:'No reassessment history available',
  confirmationIncomplete:
    'This evaluation includes {sections} only. Are you sure you would like to submit this evaluation without the completion of all three of state, pressure and response?',
  confirmationFinal: 'Are you sure you would like to submit this evaluation? Once submitted, it can no longer be edited.',
  validationMonitoring:'Some details are missing from your monitoring evaluation – please review the details provided and complete any missing information (indicated by red box and red warning text)',
  pressureTriggerValidation:'Please complete at least one trigger',
  stateEvaluationValidation:'Please complete at least one evaluation',
  nextTriggersAffected: "Next > triggers affected",
  selectedPressureTitle:"Selected Pressure",
  pressureTriggerTitle:"Select trigger species and or ecosystems that are affected",
  pressureTriggerSubTitle:"Once added to your evaluation to you can add more details",
  // monitoringStatus:'Monitoring Status',
  lastMonitored:'Last Monitored',

  // monitoring report row title
  monitorYear:'Monitoring Year',
  numberTriggers:'Triggers monitored',
  monitoringStatus:'Evaluation status',
  stateEvaluation:'State completed',
  pressureEvaluation:'Pressure Completed',
  responseEvaluation:'Response Completed',
  stateBest: 'Best State Result',
  stateWorst: 'Worst State Result',
  stateMedian: 'Median State Result',
  pressureBest: 'Best Threat Result',
  pressureWorst: 'Worst Threat Result',
  pressureMedian: 'Median Threat Result',
  pressureTotal: 'Total Threats Documented',
  coveragePa: 'Coverage by PA',
  coverageOecm: 'Coverage by OECMs',
  coveragePaOecm: 'Coverage by PA & OECMs',
  managementPlanning: 'Management Planning',
  conservationAction: 'Conservation Action',
  actionsNeededUnderwayCount: 'Actions Needed & Underway',
  actionsNeededCount: 'Actions Needed',
  actionsUnderway: 'Actions Underway',
  removeMonitoring:'Remove monitoring',
  allSpeciesAdded: 'All Species have been added to the state evaluation',
  allEcosystemsAdded: 'All ecosystem have been added to the state evaluation',
  // noRecordsFound: 'No records found',
  addSpeciesBeforeEcosystems: 'Add the selected {type} before adding {type2}.',
  revertSubmission: 'Revert submission',
  monitoringEvaluationRevertConfirmation: 'Are you sure you want to revert this monitoring evaluation?',
  enterParameter: 'Enter parameter',
  enterDetails: 'Enter details',
  Removestate: 'Remove biodiversity element',
  isPreviouslyStatedMonitoringParameter:'Is the previously stated Monitoring parameter correct?',
  isPreviouslyStatedMonitoringParameterTooltip:'Do you wish to use the existing monitoring parameter as stated above?',
  justifyPerameter : 'Please provide justification why new one needed',
  justifyPerameterTooltip:'Please provide justification why new benchmark is needed. For example is the value different because the site boundary has been amended? Or is there a better way of measuring change in abundance in this species over time?',
  benchmarkPerameterTool: 'Provide an estimate for your newly selected benchmark value for this species. Please ensure that it reflects the baseline year stated above. Your updated value will be measured against this new benchmark.',
  otherParameter : 'Other',
  enterparameter: 'Enter parameter',


}
export default englishUS